import React, { useState, useEffect } from 'react'
import { PlanHome } from "@plans/tiles";
import * as Plans from "@plans/tiles";
import { connect } from 'react-redux';
import { Service } from '../../constants/actionType';
import { ReviewDetailsModal } from '@plans-templates/review-details';
import { TextLink } from '@vds/buttons';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Body, Micro, Title } from '@vds/typography';
import { TileContainer } from '@vds/tiles'
import { Button } from '@vds/buttons'
import { Tabs, Tab } from "@vds/tabs";
import { Carousel } from '@plans/carousels';
import ReactHtmlParser from 'react-html-parser';
import { InHomeUtils } from './../../util/inhomeUtils';
import CustomRouterModal from './customRouterModal';
import CustomFiosModal from './customFiosDetailsModal';
import constants from './perks/constants';
import GiftCardModal from './giftCardModal';
import MnhModal from './mnhModal';
import OpenPerksModal from './perks/openPerksModal'
import { updateSCTags } from './../../../../Source/src/service/dtmTag';
import { updateSCTags as ecupdateSCTags, updateSCcustomEvent as ecupdateSCcustomEvent, tempSCData } from './../../../../Source/src/service/change/dtmTag';
import { useMobileView } from '../../hooks/useMobileView';
import { getCmsData } from '../midnight/services/dataFormatter';
import { getVZDLInit, updateVzdlSCCustomEvent, tempVzdlSCData, updateSandboxIdValue, updateFragmentsValue, updateDetailValue } from './../../../../Source/src/service/vzdl';
import { updateDetailValue as ecupdateDetailValue, updateNameValue } from './../../../../Source/src/service/change/vzdl'
import { YouTubeBannerDetails } from './DiscountFlowModal';
import StartNotification from "./startNotification";
import { Component } from 'react/cjs/react.production.min';
import SplOfferDispatchOverlay from './splOfferDispatchOverlay';
import { EntryPoint } from "@plans/tiles"
import * as modalAction from './../../action/modalWindow';
import EmberEntryPoint from './emberEntryPoint';
import EmberPlanHome from './emberPlanHome';
import EmberTVConnection from './emberTVConnection';
import EmberWiFiExtender from './emberWiFiExtender';
import {fetchDataMTM} from './../../action/buildProduct';

const MnTile = props => {
    const { product, clickFn, lqState, serviceType, buildProduct, isChecked, container, achorLinkTitleForTV, openModal, handleClickFiosFive, showProdBanner, signInClick, ecProfileCart, signIn, isBlocked, flowtype, acc = false, onClickAccordion = () => { }, dispatch } = props;

    const [isGigSelected, setGigSelected] = useState(false);
    const [isRouter, setIsRouter] = useState(false);
    const [isCloseBtnClick, setIsCloseButton] = useState(false);
    const [isVoice, setIsVoice] = useState(false);
    const [isCustomRouterModalOpen, setCustomRouterModalOpen] = useState(false);
    const [isCustomFiosDetailsModalOpen, setCustomFiosDetailsModalOpen] = useState(false);
    const [perksModalOpen, setPerksModalOpen] = useState(false);
    const isClassicFlow = !buildProduct?.mnFromApi;

    const [isCheckeds, setChecked] = useState(false);
    const [selectedSplOfferDetailsId, setSelectedSplOfferDetailsId] = useState(null);
    const isMobileView = useMobileView();

    const isMNHSignupIndicator = buildProduct?.internet?.mnhSignupIndicator === "Y" || buildProduct.isStaticMnhEnable;

    const parentTiles = (serviceType === Service.internet || serviceType === Service.tv || serviceType === Service.voice || serviceType === Service.mm3 || serviceType === Service.streamServ);
    const surfaceBg = (serviceType === Service.internet || serviceType === Service.tv || serviceType === Service.voice) ? 'dark' : 'light';
    const gigSpeedCodes = ['947', '941'];
    const AddOn = Plans.AddOnTile;
    const isEmployee = lqState.couponFlowType === 'Employee' || lqState.couponFlowType === 'Retiree' || (signIn && signIn?.ecFlowType && (signIn?.ecFlowType === 'Employee' || signIn?.ecFlowType === 'Retiree'));
    const isDiscountFlow = lqState.MFRTEligible && InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow && InHomeUtils.isNotNull(lqState.SweetnerMsgMFRT) && InHomeUtils.isNotNull(lqState.SweetnerMsgMFRT.discountEligible) && lqState.SweetnerMsgMFRT.discountEligible;
    const shippingPowerReserveProductIds = ["J5720", "J5721", "J5725"];
    let isShowAsLowPrice = true;
    const isDisconnectFlow = signIn?.response?.flowRoute === "FULLDISCONNECT";
    let selectedInternetProd = props.buildProduct?.internet?.selectedProduct;
    let isSkipFDVWithNGPON2 = props.buildProduct?.voice?.isSkipFDVWithNGPON2
    const isNotVerizonEmployee = props?.buildProduct?.internet?.vzEmployee === false
    const hasYouTubeProfile = props?.profileCart?.cartData?.[0]?.streamService?.streamServiceProds?.findIndex(items => items?.prodName?.toUpperCase()?.includes("YOUTUBE TV")) > -1 || ecProfileCart?.cartData?.[0]?.streamService?.streamServiceProds?.findIndex(items => items?.prodName?.toUpperCase()?.includes("YOUTUBE TV")) > -1 ? true : false;
    let loggedInStatus = InHomeUtils.getCookie('loggedIn', document.cookie) == "true";

    

    const productNameChannelLabel = () => {
        let prodLabel = "";
        if (product?.name) {
            prodLabel = product?.name?.replace('4.0', '')?.trim();
        }
        return prodLabel;
    };

    const getsplOferFrmApiAriaLabel = () => product?.splOferFrmApi?.trim() ? `${product?.productName} ${product?.splOferFrmApi}` : `A special gift, on us for ${product?.productName}`

    useEffect(() => {
        const gig = gigSpeedCodes?.indexOf(buildProduct?.internet?.selectedProduct?.speedCode) > -1;
        const router = serviceType?.indexOf('ROUTER') > -1 || serviceType?.indexOf('FNE');
        const voice = (serviceType?.indexOf('WINBACK') > -1 && serviceType?.indexOf('INTLPLAN') > -1 && serviceType?.indexOf('INTERNATIONALCHANNELPLAN' > -1));

        setGigSelected(gig);
        setIsRouter(router);
        setIsVoice(voice);
        setChecked(router)
    }, []);

    useEffect(() => {
        if (isSkipFDVWithNGPON2 && props.buildProduct?.internet?.selectedProduct?.downSpeed == "2048M") {
            dispatch({ type: 'DISABLE_VOICE_ACCOR', value: true })
        } else {
            dispatch({ type: 'DISABLE_VOICE_ACCOR', value: false })
        }
    }, [selectedInternetProd, isSkipFDVWithNGPON2]);

    useEffect(() => {
        console.log("loggedInStatus!!",loggedInStatus)
        if(loggedInStatus && !buildProduct?.wirelessLoggedInStatus) {
          fetchDataMTM(dispatch, props.visitId, props.flowType);
          dispatch({type: 'UPDATE_WIRELESS_LOGGEDIN_STATUS' , value :loggedInStatus })
        }else if(!loggedInStatus){
          dispatch({type: 'UPDATE_WIRELESS_LOGGEDIN_STATUS' , value :loggedInStatus })
        }
      }, [loggedInStatus]);

    const getStrikeOutPrice = () => {
        // Employee flow checks
        if (buildProduct?.internet?.typeOfDiscountScenario || isEmployee || buildProduct?.isVZFwdFlag || buildProduct?.isVZFCreditFlag || isDiscountFlow || isMNHSignupIndicator) {
            if (serviceType === Service.internet && buildProduct?.internet && (isEmployee || isMNHSignupIndicator || buildProduct?.internet?.strikePrice === "Y" || buildProduct?.internet?.typeOfDiscountScenario)) {
                let dPrice = product?.displayPrice;
                let oPrice = product?.originalPrice;
                let strikedOffPrice
                if (isMNHSignupIndicator) {
                    strikedOffPrice = ((parseFloat(oPrice?.replace("$", "")) - 10).toFixed(2));
                } else {
                    strikedOffPrice = "$" + ((parseFloat(oPrice?.replace("$", "")) - 10).toFixed(2));
                }
                if (isEmployee) {
                    strikedOffPrice = ((parseFloat(oPrice?.replace("$", ""))).toFixed(2));
                }
                //Making this change as we need to show striked price as originalPrice -10 after MnHSignup not original price
                if (buildProduct?.internet?.typeOfDiscountScenario) {
                    //Making this change as we need to show striked price as originalPrice -10 after MnHSignup
                    // let disPlayPrice = oPrice;
                    // if(!buildProduct?.isAPDataEnabled){
                    //   disPlayPrice = ((parseFloat(dPrice?.replace("$", "")) + 10).toFixed(2));
                    //   return disPlayPrice !== oPrice ? disPlayPrice : '';             
                    // }          
                    // return disPlayPrice;
                    return oPrice?.replace("$", "");
                }
                let diffprice = parseFloat(strikedOffPrice?.replace("$", "")) - parseFloat(dPrice?.replace("$", ""));
                if (diffprice > 0 || diffprice < 0) {
                    return strikedOffPrice;
                }
            }
        }
        const isGig = product?.id === "R3583" || product?.id === "R3582";
        const is20SpclOffer = product?.specialOffersfromApi?.findIndex(item => ["R4017"].includes(item.id)) > -1 ? true : false;
        const is10DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4021"].includes(item.id)) > -1 ? true : false;
        const is15DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4032"].includes(item.id)) > -1 ? true : false;
        const is25DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4033"].includes(item.id)) > -1 ? true : false;
        if ((is20SpclOffer && !isGig) || is10DiscOffer || is15DiscOffer || is25DiscOffer || buildProduct?.internet?.mnhSignupIndicator === "Y") {
            let originalPrice = product?.originalPrice;
            let strikedPrice = "";
            if (buildProduct?.isAPDataEnabled) {
                strikedPrice = ((parseFloat(originalPrice?.replace("$", "")) - 10).toFixed(2));
            } else {
                strikedPrice = ((parseFloat(originalPrice?.replace("$", ""))).toFixed(2));
            }
            return strikedPrice;
        }
        return '';
    };

    const generateClassicDisplayPrice = (y, product) => {
        if (y && y.indexOf("/mo") > -1) {
            y = y?.replace("/mo", "");
        }
        if (y == "$0" || y == "$0.00" || y == "$0.0") {
            y = "Included"
        }
        else if (y && y.indexOf(".00") > -1 && y.indexOf("less") == -1 && y.indexOf("more") == -1) {
            y = y?.replace(".00", "");
        }
        else if (y && y.indexOf(".00 less") > -1) {
            y = y?.replace(".00 less", " less");
        }
        else if (y && y.indexOf(".00 more") > -1) {
            y = y?.replace(".00 more", " more");
        }

        const finalPrice = y?.includes('$0') || product?.prodType === 'PREMIUM' || product?.prodType === 'INTLPREMIUM' ? '' : y?.replace('$', '');
        if (y == "Included") {
            return {
                pricingText: {
                    title: {
                        children: <>{y}</>
                    }
                }
            }
        } else {
            return {
                ...(finalPrice && {
                    newPrice: {
                        price: finalPrice,
                        term: "month",
                        superscript: "*"
                    }
                })
            };
        }
    }

    const getIcon = item => {
        const icons = {
            speed: 'download',
            wifi: 'home-internet',
            router: 'home-internet',
            price: 'lock-closed',
            voice: 'voice-hd',
            dvr: 'pause',
            storage: 'cloud',
            cloud: 'cloud',
            streaming: 'cross-device',
            stream: 'cross-device',
            accounts: 'cross-device',
            channel: 'tv',
            mgm: 'find-my-remote',
            set: 'top-box',
            rental: 'top-box',
            // international:'alternate-checkmark',
            order: 'tag',
            new: 'tag',
            paramount: 'find-my-remote',
            cancel: 'no'
        };
        const ic = Object.keys(icons)?.find(icon => {
            if (item.toLowerCase().includes(icon) && !item.toLowerCase().includes('recommend')) {
                return icon;
            }
        });
        return icons[ic];
    };

    const handleCloseSignClick = (e) => {
        if (e === false && !isCloseBtnClick) {
            updateSCTags('Close sign');
        } else {
            setIsCloseButton(false);
        }
        setSelectedSplOfferDetailsId(null);
    }

    const openFiosTvOneDetail = () => {
        setCustomFiosDetailsModalOpen(true);
    }

    const getSubAccordionReviewDetails = (productReviewDts, prodId) => {
        try {
            const title = productReviewDts[0];
            if (Array.isArray(productReviewDts) && productReviewDts.length > 0) {
                productReviewDts?.shift();
            }
            return (
                <div>
                    <Modal
                        toggleButton={
                            <button onClick={(e) => { updateSCTags('Review Details') }} className="reviewDetailsbtn" ariaLabel={"Review Details " + product?.productName?.replace('4.0', '')} role="button" tabIndex={0} ariaHidden={false} >Review details</button>
                        }
                        onClose={(e) => { handleCloseSignClick(e) }}
                    >
                        <ModalBody>
                            {productReviewDts?.map(item => {
                                if (product?.id === 'R0704' || product?.prodType === 'SPLOFFER') {
                                    if (item.title) {
                                        item['title'] = replaceDynamicVals(item.title);
                                    }
                                    if (item.subtitle) {
                                        item['subtitle'] = replaceDynamicVals(item.subtitle);
                                    }
                                }
                                let processedTitle = ((prodId === 'R4047' || prodId === 'R4142') && (props?.buildProduct?.internet?.selectedProduct?.name?.toLowerCase()?.includes("2 gig") ||
                                    props?.buildProduct?.internet?.selectedProduct?.prodName?.toLowerCase()?.includes("2 gig"))) ?
                                    "Get Netflix & Max (With Ads) Perk for 12 months, on us with the 2 Gig plan." : (prodId === 'R4047' || prodId === 'R4142' && (props?.buildProduct?.internet?.selectedProduct?.name?.toLowerCase()?.includes("1 gig") ||
                                        props?.buildProduct?.internet?.selectedProduct?.prodName?.toLowerCase()?.includes("1 gig"))) ?
                                        "Get Netflix & Max (With Ads) Perk for 12 months, on us with the 1 Gig plan." : item?.title
                                const handleClose = () => {
                                    setIsCloseButton(true)
                                    updateSCTags("close button")
                                    setTimeout(() => {
                                        document.getElementById('close-button').click()
                                    }, 1000)
                                }
                                return (
                                    <>
                                        <Title size='small' bold={true} primitive='h2'>
                                            <span style={{ fontSize: '16px' }} dangerouslySetInnerHTML={{ __html: processedTitle }} />
                                            <br />
                                        </Title>
                                        <Body size='medium'>
                                            {
                                                product?.id === "R0529" || product?.id === "NOCEAPPS" ? <>
                                                    <img alt="FireTv" src={require('./../../assets/ak-cached/24h/img/streaming/apple-tv-4k-32gb.jpeg').default} width="100px" />
                                                    <img alt="FireStick" src={require('./../../assets/ak-cached/24h/img/streaming/Fire-Stick.jpeg').default} width="100px" />
                                                    <img alt="FireTv" src={require('./../../assets/ak-cached/24h/img/streaming/Fire-Cube.jpeg').default} width="100px" />
                                                    <img alt="StreamTV" src={require('./../../assets/ak-cached/24h/img/streaming/Stream-TV.png').default} width="100px" />
                                                </> :
                                                    product?.id === "R1853" || product?.id === "R0529" || product?.id === "R1730" || product?.id === "R1749" || product?.id === "R0703" || product?.id === "R1767" || product?.id === "R0702" || product?.id === "R1739" ? <>
                                                        <img alt="Router" style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "50%" }} src={require('./../../assets/ak-cached/24h/img/Router/Router.png').default} width="240px" />
                                                    </> : <></>
                                            }
                                            <span dangerouslySetInnerHTML={{ __html: item.subtitle }} />
                                            <br />
                                        </Body>
                                        {
                                            item?.helperText && product?.prodTypeValue === 'YOUTUBE' && <>
                                                <Micro color='#6f7171' primitive='span'>
                                                    {item.helperText}
                                                    <br />
                                                </Micro>
                                            </>
                                        }
                                    </>
                                )
                            })}
                        </ModalBody>
                        <ModalFooter
                            buttonData={{
                                primary: {
                                    width: 'auto',
                                    children: 'Close',
                                    onClick: () => document.getElementById('close-button').click()
                                },
                            }}
                        />
                    </Modal>
                </div>
            )
        } catch (e) {

            return null;
        }
    }

    const getSubTitleForSplOffer = prodId => {
        if (prodId === 'R4010' || prodId === 'R4011' || prodId === 'R4009') {
            return <Body size='small' color='#6E6B65'>
                $10/mo after. Select Disney Bundle Perk to receive offer.
            </Body>
        } else if (prodId === 'R4047' || prodId === 'R4142') {
            return <Body size='small' color='#6E6B65' primitive='span'>
                $10/mo after&nbsp;
            </Body>
        } else if (prodId === 'R4049' || prodId === 'R4140') {
            return <Body size='small' color='#6E6B65' primitive='span'>
                Xbox Stereo Headset, Xbox Wireless Controller and $50 Xbox gift card.&nbsp;
            </Body>
        } else {
            return <></>;
        }
    }

    const getSpecialOfferReviewDetails = (prodId, offerText) => {
        try {
            const internetCmsProds = getCmsData();
            const cmsProds = internetCmsProds?.[prodId];
            const productReviewDts = cmsProds && cmsProds?.reviewDetails ? cmsProds?.reviewDetails : [];

            if (Array.isArray(productReviewDts) && productReviewDts.length > 0) {
                productReviewDts?.shift();
            }
            if (productReviewDts?.length > 0) {
                return (
                    <div>
                        {
                            getSubTitleForSplOffer(prodId)
                        }
                        <Modal
                            onClose={(e) => { handleCloseSignClick(e) }}
                            opened={selectedSplOfferDetailsId === prodId}
                            onOpenedChange={(e) => setSelectedSplOfferDetailsId(prodId)}
                            toggleButton={
                                <span onClick={(e) => { updateSCTags('Details'); setSelectedSplOfferDetailsId(prodId) }}><TextLink role="button" ariaLabel={"Details " + offerText}>
                                    Details</TextLink>
                                </span>
                            }
                            id={`${isMobileView ? 'mnTile_reviewModal_mobile' : 'mnTile_reviewModal'}`}
                        >
                            {productReviewDts?.map(item => {
                                let processedTitle = ((prodId === 'R4047' || prodId === 'R4142' || prodId === 'R4261') && product?.name?.toLowerCase()?.includes("2 gig")) ?
                                    "Get Netflix & Max (With Ads) Perk for 12 months, on us with the 2 Gig plan." : (prodId === 'R4047' || prodId === 'R4142' || prodId === 'R4261' && product?.name?.toLowerCase()?.includes("1 gig")) ?
                                        "Get Netflix & Max (With Ads) Perk for 12 months, on us with the 1 Gig plan." : item?.title
                                return (
                                    <>
                                        <ModalTitle>
                                            <span dangerouslySetInnerHTML={{ __html: processedTitle }}></span>
                                        </ModalTitle>
                                        <ModalBody>
                                            {
                                                product?.id === "R0529" || product?.id === "NOCEAPPS" ? <>
                                                    <img alt="FireTv" src={require('./../../assets/ak-cached/24h/img/streaming/apple-tv-4k-32gb.jpeg').default} width="100px" />
                                                    <img alt="FireStick" src={require('./../../assets/ak-cached/24h/img/streaming/Fire-Stick.jpeg').default} width="100px" />
                                                    <img alt="FireTv" src={require('./../../assets/ak-cached/24h/img/streaming/Fire-Cube.jpeg').default} width="100px" />
                                                    <img alt="StreamTV" src={require('./../../assets/ak-cached/24h/img/streaming/Stream-TV.png').default} width="100px" />
                                                </> : <></>
                                            }
                                            <span dangerouslySetInnerHTML={{ __html: item?.subtitle }}></span>
                                            {
                                                item?.helperText ?
                                                    <span style={{ fontSize: '11px' }} dangerouslySetInnerHTML={{ __html: item?.helperText }} />
                                                    : <></>
                                            }
                                        </ModalBody>
                                        <ModalFooter
                                            buttonData={{
                                                primary: {
                                                    width: '100%',
                                                    children: (prodId === 'R4010' || prodId === 'R4011' || prodId === 'R4009') ? 'Got it' : 'Close',
                                                    onClick: () => {
                                                        setIsCloseButton(true)
                                                        updateSCTags("close button")
                                                        setSelectedSplOfferDetailsId(null);
                                                        setTimeout(() => {
                                                            try {
                                                                document.getElementById('close-button').click()
                                                            } catch (e) {
                                                                //console.error(e);
                                                            }
                                                        }, 1000)
                                                    }
                                                }
                                            }}
                                        ></ModalFooter>
                                    </>
                                )
                            })}
                        </Modal>
                    </div>
                )
            }
        } catch (e) {
            return null;
        }
    }

    const formatExtrasForData = prod => {
        // const saveTheSaleOffersRestrictDisplay = ['R3883', 'R3884','R3885'];
        // const removeOffersSpl = ["Q9938", "Q9939", "Q9940", "Q9944", "Q9945", "Q9946", "Q9947", "P0256", "P0257", "Q9942", "Q9941", "Q9943", "P0255", "P0254", "R1987", "R1986", "P0256", "Q9947", "Q9951", "Q9952", "Q9953" ]
        // const splRemoveofferList =["R1345", "Q9938", "Q9939", "Q9941", "Q9942", "Q9943", "Q9951", "Q9947", "Q9940","R1986", "R1987", "P0255", "P0256", "P0254", "P0257","P0256", "Q9947", "Q9946", "Q9945", "Q9944", "Q9951", "Q9952", "Q9953" ]
        let is500Plan = prod?.name?.toLowerCase()?.includes("500")

        const contentObj = [];

        let specialOffersfromApiArr = prod?.specialOffersfromApiArr?.[0];

        let special = specialOffersfromApiArr?.filter((spl) => spl?.id == "R4142");
        if (special?.length > 0) {
            specialOffersfromApiArr = specialOffersfromApiArr?.filter(i => !(
                i?.id === 'R4093'  // black friday xbox series s
            ))
        }

        if (specialOffersfromApiArr?.length > 0) {
            contentObj.push({
                title: {
                    children: 'Your choice of:'
                },
                // items: prod?.specialOffersfromApiArr?.[0]?.filter((isocid) => !splRemoveofferList?.includes(isocid?.id))?.map(extra => {
                items: specialOffersfromApiArr?.filter((spl) => spl?.offerFor === 'Data' && spl?.BsOfferAttrValue !== 'NETMAX_PERK_MARKER')?.map(extra => {

                    return {
                        title: {
                            children: <Body color='#000000'>
                                <span style={{ fontWeight: "bold" }}>{extra?.OfferText}</span>
                            </Body>
                        },
                        subtitle: {
                            children: getSpecialOfferReviewDetails(extra?.id, extra?.OfferText)
                        }
                    }
                })
            });
        }
        console.log('prod?.specialOffersfromApiArr', prod?.specialOffersfromApiArr)
        if (prod?.specialOffersfromApiArr?.[1].length > 0) {
            contentObj.push({
                ...(prod?.specialOffersfromApiArr?.[1]?.length > 0
                    ? {
                        title: {
                            children: "Also included on us:"
                        }
                    }
                    : null
                ),
                // items: prod?.specialOffersfromApiArr?.[1]?.filter((isocid) => !saveTheSaleOffersRestrictDisplay?.includes(isocid?.id) && !removeOffersSpl?.includes(isocid?.id))?.map(extra => {
                items: prod?.specialOffersfromApiArr?.[1]?.filter((spl) => spl.offerFor === 'Data' && spl?.BsOfferAttrValue !== 'NETMAX_PERK_MARKER' && spl?.BsOfferAttrValue !== '$50_XBOX_BUNDLE_GC_DISCOUNT_CM24').map(extra => {
                    return {
                        title: {
                            children: <Body color='#000000' >
                                <span style={{ fontWeight: "bold" }}>  {is500Plan ? ('Bonus: ' + extra?.OfferText?.replace('1 Gig', '500 Mbps')) : (extra.id == "R4139" ? extra?.OfferText?.replace('Console On Us', '') : 'Bonus: ' + extra?.OfferText)}</span>
                            </Body>
                        },
                        subtitle: {
                            children: getSpecialOfferReviewDetails(extra?.id, extra?.OfferText)
                        }
                    }
                })
            });
        }

        return {
            header: {
                badge: {
                    children: (
                        <>
                            <span aria-label={`A special gift, on us ${product?.productName}`}>
                                <span aria-hidden="true">A special gift, on us </span>
                            </span>
                        </>
                    ),
                    fillColor: 'red'
                },
                title: {
                    children: prod?.splOferFrmApi
                },
                ariaLabel: getsplOferFrmApiAriaLabel()
            },
            content: contentObj,
            onClick: serviceType === Service.internet ? null : onClickAccordion,
            open: props.acc
        }
    };

    const handleDetails = (e, extra, prod) => {
        let name = prod?.productName?.replace('4.0', '');
        if (props?.flowtype == "EC") {
            //  tempSCData.detailPageName= name;
            ecupdateDetailValue(name);
            tempSCData.detailPageName = extra?.OfferText + ' - details';
            ecupdateSCcustomEvent("buildFiosInitEC", "pageViewOmni", "detailPageName,events");
            ecupdateSCTags("Details");

        } else {
            setTimeout(() => {
                tempVzdlSCData.detail = name;
                updateDetailValue(name);
                updateSCTags("Details");
            }, 1000);
            tempVzdlSCData.detail = extra?.OfferText + ' - details';
            updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events");
        }
    }

    const formatExtras = prod => {
        return {
            badge: {
                children: 'A special gift, on us',
                fillColor: prod?.name === '1 Gig' || prod?.name === '2 Gig' || prod?.name === '2 Gig 4.0' ? 'red' : prod?.type === 'TV' ? 'red' : 'white'
            },
            content: <>
                {prod?.extras?.map(extra => {
                    return <Body color='#000000'>
                        {extra.OfferText}
                        {(typeof extra?.OfferText === "string" && extra?.OfferText?.toUpperCase()?.includes("VERIZON GIFT CARD")) && (
                            <span onClick={(e) => { handleDetails(e, extra, prod) }}>
                                &nbsp; <GiftCardModal title={extra?.OfferText} />
                            </span>
                        )}
                    </Body>
                })}
            </>
        }
    };

    const getAsLowAsPrice = () => {
        const mnhSignupIndicator = buildProduct?.internet?.mnhSignupIndicator || buildProduct.isStaticMnhEnable === true ? 'Y' : '';
        const isMax500plan = buildProduct?.internet?.m2mPlans?.findIndex(item => ["R3582", "R3583"].includes(item?.id)) == -1;
        const isGigPlan = buildProduct?.internet?.m2mPlans?.findIndex(item => ["R3582", "R3583"].includes(item?.id)) > -1;
        const is25MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3726", "R3728", "R3729", "R4033"].includes(item?.id)) > -1
        const is15MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3725", "R3727", "R4032"].includes(item?.id)) > -1
        const isTWSFlow = buildProduct?.internet?.typeOfDiscountScenario === "TWS" || props?.buildProduct?.internet?.typeOfDiscountScenario === "TSW" || props?.buildProduct?.isTWSFlag === "Y";
        const is10TWSOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["38412"].includes(item?.OfferId)) > -1
        const is5TWSOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["37486"].includes(item?.OfferId)) > -1
        const price = (+product?.price);
        const is20SpclOffer = product?.specialOffersfromApi?.findIndex(item => ["R4017"].includes(item.id)) > -1 ? true : false;
        let is15DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4032"].includes(item.id)) > -1 ? true : false;
        let is25DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4033"].includes(item.id)) > -1 ? true : false;
        // If autopay is enabled then add autopay discount 
        let autopayDiscount = 0;
        let autopayPrice = 0;
        product?.specialOffersfromApi?.map?.((item, index) => {
            if(item?.BsOfferAttrValue?.toLowerCase()?.includes?.("autopay") && !item?.BsOfferAttrValue?.toLowerCase?.()?.includes?.("decline")){
                autopayPrice = Number(item?.Price);
            }
        });
        autopayDiscount = buildProduct?.isAPDataEnabled ? 0 : autopayPrice;
        // Add mnh discount depending on mnhSignupIndicator, internet plan, and special offers
        let mnhDiscount = 0;
        if (mnhSignupIndicator === "Y" && (is25MNHOfferAvailable || is15MNHOfferAvailable)) {
            mnhDiscount = 0;
        } else if ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !is25MNHOfferAvailable && !is15MNHOfferAvailable) {
            mnhDiscount = (+product?.mnhDiscount);
        } else if (
            (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && isGigPlan && !isMax500plan)
            || (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id == "R3584"))
        ) {
            mnhDiscount = 25;
        } else if (
            (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && !isMax500plan)
            || (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id != "R3584"))
        ) {
            mnhDiscount = 15;
        } else if (
            ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && isGigPlan && !isMax500plan && is25MNHOfferAvailable && !is15MNHOfferAvailable)
            || ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !isGigPlan && isMax500plan && (product?.id == "R3584") && is25MNHOfferAvailable && !is15MNHOfferAvailable)
        ) {
            mnhDiscount = -25;
        } else if (
            ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !isGigPlan && !isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)
            || ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !isGigPlan && isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)
        ) {
            mnhDiscount = -15;
        } else {
            mnhDiscount = 0;
        }
        // Add tws discount depending on special offers
        let twsDiscount = 0;
        if (isTWSFlow && is10TWSOfferAvailable) {
            twsDiscount = 10;
        } else if (isTWSFlow && is5TWSOfferAvailable) {
            twsDiscount = 5;
        }
        // Calculate as low as price
        let asLowAsPrice = price - mnhDiscount - twsDiscount + autopayDiscount; // PRODDEF-34778: D/T/M_FiosNC_M+H Pricing when APO toggle off is Incorrect i.e. It should increase by 10 if APO is toggle off
        if (asLowAsPrice < 0) {
            asLowAsPrice = 0;
        }
        if (is15DiscOffer || is25DiscOffer) {
            let deductionPrice = is15DiscOffer ? 15
                : is25DiscOffer ? 25
                    : 0;
            let asLowAsPrice = (parseFloat(product?.displayPrice?.replace("$", "")) - deductionPrice).toFixed(2);
            return asLowAsPrice;
        }
        if (is20SpclOffer && isGigPlan && buildProduct?.internet?.isLeadListAddress && buildProduct?.isAPDataEnabled) {
            let asLowAsPrice = (parseFloat(product?.displayPrice?.replace("$", "")) - 20).toFixed(2);
            return asLowAsPrice;
        }
        return asLowAsPrice.toFixed(2);
    };

    const checkIfRemovedInDisconnect = () => {
        if (serviceType === Service.internet || serviceType === Service.mm3) {
            return buildProduct?.internet?.disconnected;
        } else if (serviceType === Service.tv) {
            return buildProduct?.tv?.disconnected;
        } else if (serviceType === Service.voice) {
            return buildProduct?.voice?.disconnected;
        }
    };

    const getEcCtaText = (notProfileServices) => {
        if (isDisconnectFlow) {
            return checkIfRemovedInDisconnect() ? 'Removed' : 'Remove';
        } else {
            if (notProfileServices) {
                return isChecked ? "Remove" : "Select";
            }
            return checkIfRemovedInDisconnect() ? 'Removed' : 'Selected';
        }
    };

    const openChannels = (e, product) => {
        openModal(e);
        let name = product?.productName?.replace('4.0', '');
        setTimeout(() => {
            tempVzdlSCData.detail = name;
            updateDetailValue(name);
            updateSCTags('Channels');
        }, 1000);
        updateDetailValue(name + ' - Channels');
    };

    const handleReview = (e, product) => {
        let name = product?.productName?.replace('4.0', '');
        if (props?.flowtype == "EC") {
            ecupdateDetailValue(`${name} - review details `);
            if (props?.buildProduct?.internet?.isAccordionOpen === true) {
                tempSCData.detailPageName = `${name} - review details `
                ecupdateSCcustomEvent("buildFiosInitEC", "pageViewOmni", "detailPageName,events");
            } else if (props?.buildProduct?.tv?.isAccordionOpen === true) {
                tempSCData.detailPageName = `${name} - review details `
                ecupdateSCcustomEvent("buildFiosInitEC", "pageViewOmni", "detailPageName,events");
            }
            setTimeout(() => {
                ecupdateSCTags('Review Details', '', name);
            }, 200)
        } else {
            setTimeout(() => {
                updateDetailValue(name);
                tempVzdlSCData.detail = name;
                updateSCTags('Review Details');
            }, 1000);
            if (props?.buildProduct?.internet?.isAccordionOpen === true) {
                tempVzdlSCData.detail = name + ' - review details'
                updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events");
            } else if (props?.buildProduct?.tv?.isAccordionOpen === true) {
                tempVzdlSCData.detail = name + ' - review details'
                updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events");
            }
        }
    };

    const getProdTitleWidth = product => {
        let title = product?.productName ? product?.productName : product?.name;
        let titleWidth = '';
        if (product?.name === 'YouTube TV') {
            title = <img src='http://s7.vzw.com/is/image/VerizonWireless/YTTV%5FLogo%5FBlackType?$pngalpha$' alt='YouTube TV' ariaLabel='YouTube TV' tabIndex='0' />
        } else if (isClassicFlow) {
            title = product?.name;
        }

        if (isMobileView && (product?.prodType === 'FTTPD')) {
            titleWidth = '90px';
        } else {
            if ((props?.flowtype == "EC" && (title === '300 Mbps' || title === '500 Mbps')) || (title === 'The Most Fios TV' || title === 'Fios TV Test Drive' || product?.name === 'YouTube TV')) {
                titleWidth = '110px';
            } else {
                titleWidth = product?.productName === 'Your Fios TV Spotlight'
                    ? '126px'
                    : (product?.productName === 'Fios Home Phone') ? '120px' : '130px';
            }
        }

        return {
            children: title,
            width: titleWidth
        };
    };

    const getProdPrice = (product, formattedPriceWithAP, formattedPriceWithoutAP) => {

        if (product?.prodType === 'FVPRIMARY') {
            return parseInt(product?.price?.replace('less', '')?.replace('more', ''));
        } else if (props.buildProduct?.isAPDataEnabled) {
            if (product?.prodType != "FTTPD") {
                if (props.buildProduct?.tv?.selectedProduct == null) {
                    // Hardcoding YTTV price to 72.99 as per Business confirmation for MIDNITE-1591
                    return (!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE') && product?.price ? parseFloat(product?.price) - 10 : parseFloat(product?.price);
                } else if (product?.price?.toString()?.includes('more') || product?.price?.toString()?.includes('less')) {
                    return product?.price?.toString()?.replace('.00', '') + '/mo*';
                } else {
                    return (!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE') && product?.price ? parseFloat(product?.price) - 10 : parseFloat(product?.price);
                }
            } else {
                return formattedPriceWithAP;
            }
        } else if (product?.prodType != "FTTPD") {
            if (product?.prodTypeValue === 'YOUTUBE') {
                // Hardcoding YTTV price to 72.99 as per Business confirmation for MIDNITE-1591
                return (!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE') && product?.price ? parseFloat(product?.price) - 10 : parseFloat(product?.price);
            } else {
                return (parseFloat(product?.price)) + 10; // PRODDEF-34778: YouTube TV price should not change when APO toggle is turned off, it should stay as $72.99 even when toggle is turned off
            }
        } else {
            return formattedPriceWithoutAP;
        }
    };

    const getYTTVTooltipContent = () => {
        return <>
            <Body size='small'>
                <p style={isMobileView ? { fontSize: '20px', fontWeight: 700 } : { fontSize: '12px', fontWeight: 700 }}>
                    New Youtube TV subscribers save $10/mo for 12 months.
                </p>
                <span style={isMobileView ? { fontSize: '16px' } : { fontSize: '12px' }}>
                    Offer available to Verizon Home Internet customers who are not a current or prior YouTube TV subscriber or trial user previously. Must activate YouTube TV subscription through YouTube TV w/in 90 days of new home internet activation/installation or when added to an existing internet plan. $10/month discount for 12 months on the standard subscription price, currently <span>{product?.displayPrice}/mo</span>. (subject to change); discount ends if home internet service is canceled (subscription will continue to be billed at the standard subscription price unless you cancel with YouTube TV by going to your YouTube TV settings). At the end of 12-month period you will be automatically charged the then-current standard subscription price monthly until you cancel. Must be 18 years or older. Valid form of payment required. Redeemable where YouTube TV is available. Full terms here: <a href="https://www.youtube.com/t/terms_paidservice" target="_blank">www.youtube.com/t/terms_paidservice</a>. Promotional value of subscription(s) are non-transferable, not for resale, and not redeemable for cash. Offer available in markets where YouTube TV service is available.
                </span>
            </Body>
        </>
    };
    function getPriceGuarantee (uniqPromo) {
        let subText = '';
        subText = uniqPromo?.[2];
        let showPriceBadge = (subText!= '' && subText != undefined)? true: false;
        let newPriceGuarantee={};
        if(showPriceBadge) {
          newPriceGuarantee.priceBadge = {
            children : <span class='priceGswat'>{subText}</span>,
              fillColor : "neonYellow",
                icon : {
                  name : "lock-closed"
                }
              }
       return newPriceGuarantee
        }
        else {
          return null
        }
      }
    const getVZFwdTooltip = () => {
        return <>
            <Body size='medium' color='#ffffff'>
                Get service for as low as $0/mo for 6 months with the Verizon Forward Credit
            </Body>
            <Body size='medium' color='#6F7171'>
                Promo credit ends if eligibility requirements are no longer met. After 6 months, you will be charged the then-current price. Must install/activate eligible service by 9.30.24.
            </Body>
        </>
    };

    const formatProdForSB = (product) => {
        const strikeOutPrice = getStrikeOutPrice();
        let mnhSignupIndicator = (buildProduct?.internet?.mnhSignupIndicator === 'Y' || buildProduct.isStaticMnhEnable === true) ? 'Y' : 'N';
        let isMax500plan = buildProduct?.internet?.m2mPlans?.findIndex(item => ["R3582", "R3583"].includes(item?.id)) > -1 ? false : true;
        let isGigPlan = product?.id === "R3583" || product?.id === "R3582";
        let is25MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3728", "R3729"].includes(item?.id)) > -1 ? true : false
        let is15MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3727"].includes(item?.id)) > -1 ? true : false
        let is20SpclOffer = product?.specialOffersfromApi?.findIndex(item => ["R4017"].includes(item.id)) > -1 ? true : false;
        let blackFridayandCyberMonArray = buildProduct?.internet?.m2mPlans?.filter(item => item?.id === "R3583" || item?.id === "R3582");
        let isBlackFridayOrCyberMonday = blackFridayandCyberMonArray[0]?.specialOffers?.findIndex(item => ["R4139", "R4093"].includes(item?.id)) > -1 ? true : false;
        let formattedPriceWithAP =
            (mnhSignupIndicator === "" &&
                !is25MNHOfferAvailable &&
                !is15MNHOfferAvailable) ||                       // handling unauth non MNH
                (mnhSignupIndicator === "Y" && (is25MNHOfferAvailable || is15MNHOfferAvailable)) // handling auth MNH
                ? (+product?.price).toFixed(2)
                : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && isGigPlan && !isMax500plan && isNotVerizonEmployee) ? (((+product?.price) - 25).toFixed(2))
                    : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && !isMax500plan && isNotVerizonEmployee) ? (((+product?.price) - 15).toFixed(2))
                        : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id == "R3584") && isNotVerizonEmployee) ? (((+product?.price) - 25).toFixed(2))
                            : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id != "R3584") && isNotVerizonEmployee) ? (((+product?.price) - 15).toFixed(2))
                                : (((mnhSignupIndicator === "N" && isGigPlan && !isMax500plan && is25MNHOfferAvailable && !is15MNHOfferAvailable) ||
                                    (mnhSignupIndicator === "" && isGigPlan && !isMax500plan && is25MNHOfferAvailable && !is15MNHOfferAvailable)) ? (((+product?.price) + 25).toFixed(2)) :
                                    ((mnhSignupIndicator === "N" && !isGigPlan && !isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable) ||
                                        (mnhSignupIndicator === "" && !isGigPlan && !isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)) ? (((+product?.price) + 15).toFixed(2)) :
                                        ((mnhSignupIndicator === "N" && !isGigPlan && isMax500plan && (product?.id == "R3584") && is25MNHOfferAvailable && !is15MNHOfferAvailable) ||
                                            (mnhSignupIndicator === "" && !isGigPlan && isMax500plan && (product?.id == "R3584") && is25MNHOfferAvailable && !is15MNHOfferAvailable)) ? (((+product?.price) + 25).toFixed(2)) :
                                            ((mnhSignupIndicator === "N" && !isGigPlan && isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable) ||
                                                (mnhSignupIndicator === "" && !isGigPlan && isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)) ? (((+product?.price) + 15).toFixed(2)) :
                                                (+product?.price).toFixed(2)
                                );
        let autopayDiscount = 0;
        let autopayPrice = 0;
        product?.specialOffersfromApi?.map?.((item, index) => {
            if (item?.BsOfferAttrValue?.toLowerCase()?.includes?.("autopay") && !item?.BsOfferAttrValue?.toLowerCase?.()?.includes?.("decline")) {
                autopayPrice = Number(item?.price);
            }
        });
        autopayDiscount = buildProduct?.isAPDataEnabled ? 0 : autopayPrice;
        let formattedPriceWithoutAP = +formattedPriceWithAP && ((+formattedPriceWithAP) + autopayDiscount).toFixed(2)

        const isTWSFlow = props?.buildProduct?.internet?.typeOfDiscountScenario === "TWS"
            || props?.buildProduct?.internet?.typeOfDiscountScenario === "TSW"
            || props?.buildProduct?.isTWSFlag === "Y";
        isShowAsLowPrice = isTWSFlow ? true : (mnhSignupIndicator === "Y") ? false : ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !(is25MNHOfferAvailable || is15MNHOfferAvailable)) ? true : false

        let formattedAsLowPriceWithAP =
            mnhSignupIndicator === "" &&
                !is25MNHOfferAvailable &&
                !is15MNHOfferAvailable
                ? (+product?.price - +product?.mnhDiscount).toFixed(2)
                : (+product?.price).toFixed(2);

        let formattedAsLowPriceWithoutAP = +formattedAsLowPriceWithAP && ((+formattedAsLowPriceWithAP) + 10).toFixed(2);
        const disableTV = ((props.buildProduct?.internet?.selectedProduct === null && product?.prodTypeValue === "ULTIMATETESTDRIVE") ||
            (props.buildProduct?.internet?.selectedProduct === null && product?.prodTypeValue === "YOUTUBE" && props.buildProduct?.internet?.m2mPlans?.filter((each) => each.isprdOnProfile && !each.isprdRemoved).length === 0))
        const uniqPromo = [...new Set(product?.equipPromo)]?.filter(n => n);
        let is5YearPriceGuarantee = uniqPromo?.findIndex(item => item?.toLowerCase()?.includes('5-year price guarantee')) > -1 ? true : false;
        //to show as low as for $20 - swat 179
        if (is20SpclOffer && buildProduct?.internet?.isLeadListAddress) {
            isShowAsLowPrice = false;
            if (isGigPlan) {
                isShowAsLowPrice = buildProduct?.isAPDataEnabled ? true : false;
            }
        }
        //to show as low as for black friday and cyber monday without lead list so that it doesn't collide with swat179
        if (isBlackFridayOrCyberMonday && (buildProduct?.internet?.isLeadListAddress != true) && mnhSignupIndicator !== "Y") {
            isShowAsLowPrice = true;
        }
        return {
            title: {
                ...getProdTitleWidth(product),
            },
            ...(strikeOutPrice && {
                oldPrice: {
                    leadingText: {
                        children: 'was'
                    },
                    price: strikeOutPrice,
                    term: 'month'
                }
            }),
            ...(!buildProduct?.isVZFCreditFlag && (!isClassicFlow && (product?.displayPrice?.replace("$", "")) != 0.0
                ? {
                    newPrice: {
                        price: getProdPrice(product, formattedPriceWithAP, formattedPriceWithoutAP),
                        term: props?.buildProduct?.tv?.selectedProduct !== null && product?.type === 'TV' && (product?.price?.toString()?.includes('more') || product?.price?.toString()?.includes('less')) ? "none" : "month",
                        leadingText: {
                            children: product?.productName === 'Fios Home Phone' ? '' : '',
                        },
                        superscript: (product?.type === 'TV' || serviceType == Service.tv) ? (!hasYouTubeProfile && product?.prodTypeValue === 'YOUTUBE' && lqState?.runtimeKey?.enableYTTV === 'Y' ?  lqState?.runtimeKey?.enablePromoFooterNotes==='Y' ? '**' : "1" : '*') : '',
                        alignment: 'right',
                        size: 'medium'
                    },
                    ...(!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE' && {
                        oldPrice: {
                            leadingText: {
                                children: <s>reg</s>
                            },
                            price: product?.originalPrice ? product?.originalPrice : "82.99",
                            term: "month",
                            strikethrough: true
                        },
                        autoPayPrice: {
                            trailingText: {
                                children: <span style={{ fontSize: "0.70rem" }}>for new subscribers</span>
                            },
                            size: '2XSmall',
                            price: '',
                            color: 'secondary',
                            term: 'none',
                            hideCurrency: true
                        },
                        discountPrice: {
                            leadingText: {
                                children: 'for 1 year'
                            },
                            size: '2XSmall',
                            alignment: 'right',
                            price: '',
                            term: 'none',
                            color: 'secondary',
                            hideCurrency: true,
                            tooltip: {
                                ariaLabel: 'More information about New Youtube TV subscribers save $10/mo for 12 months tooltip',
                                children: getYTTVTooltipContent()
                            }
                        }
                    })
                } : isClassicFlow ? generateClassicDisplayPrice(product?.displayPrice, product) : '')),
            ...(isShowAsLowPrice && !isEmployee && !buildProduct?.isVZFCreditFlag && product?.mnhDiscount && props?.flowtype != "EC" && {
                discountPrice: {
                    color: 'secondary',
                    leadingText: {
                        children: "As low as",
                    },
                    price: getAsLowAsPrice(),
                    term: 'month',
                    trailingText: {
                        children: <MnhModal mnhTooltip={product?.mnhTooltip}
                            formattedWasPriceWithAP={formattedAsLowPriceWithAP}
                            signInClick={signInClick} dispatch = {props.dispatch}/>,
                    },
                }
            }),
            ...(buildProduct?.isVZFCreditFlag && {
                newPrice: {
                    price: '0',
                    term: "month"
                },
                discountPrice: {
                    trailingText: {
                        children: 'after 6 mos'
                    },
                    price: (parseFloat(product?.displayPrice?.replace('$', ''))).toFixed(2),
                    term: 'none',
                    tooltip: {
                        surface: 'light',
                        maxHeight: '120px',
                        ariaLabel: 'More information about verizon forward credit tooltip',
                        title: InHomeUtils.getdeviceType() === 'desktop' ? 'Verizon Forward 6 Credit' : 'Get discounted service for 6 months with the Verizon Forward Credit',
                        children: getVZFwdTooltip()
                    }
                }
            }),
            ...((serviceType === Service.internet || serviceType=== Service.mm3)&&!isClassicFlow &&  lqState?.runtimeKey?.PriceGuarantee =='Y' ? getPriceGuarantee(uniqPromo):null ),
            details: {
                items: uniqPromo?.map((equip, index) => {
                    let subtitle = "";
                    if (equip?.includes("|")) {
                        const titleNSub = equip?.split("|");
                        equip = titleNSub[0];
                        subtitle = titleNSub[1];
                    }
                    let newPriceGuarantee = false;
          if(equip?.toLowerCase?.()?.includes?.('3-year price lock guarantee') || equip?.toLowerCase?.()?.includes?.('4-year price lock guarantee') || equip?.toLowerCase?.()?.includes?.('5-year price lock guarantee')|| equip?.toLowerCase?.()?.includes?.('2-year price guarantee')||equip?.toLowerCase?.()?.includes?.('3-year price guarantee')||equip?.toLowerCase?.()?.includes?.('4-year price guarantee')){
            newPriceGuarantee = true;
          }
          return {
            ...(!isClassicFlow &&!(props?.lqState?.runtimeKey?.PriceGuarantee =='Y' && newPriceGuarantee)  &&{ icon: { name: getIcon(equip),alignment: 'middle',  size: 'large', ariaHidden: true },}),
            title: {
              children: (props?.lqState?.runtimeKey?.PriceGuarantee =='Y' && newPriceGuarantee) ? '' : (<span dangerouslySetInnerHTML={{ __html: equip }} />)
            },
            subtitle: {
              children: subtitle?.toLowerCase?.()?.includes('available for a limited time') ? <span style={{ left: 32, position: 'relative' ,bottom:'32px'}} >{subtitle}</span> : subtitle
            }
          }
                }),
                ...((serviceType == "TV"
                    ? product?.reviewTVDetails
                    : product?.equipPromo) && {
                        leftTextLink: {
                            tabIndex: 0,
                            ariaLabel: "Review Details " + product?.productName,
                            role: "menu",
                            onClick: (e) => { handleReview(e, product) },
                            onTouchStart: (e) => { handleReview(e, product) },
                            onKeyDown: (e) => {
                                if (e.keyCode === 32 || e.keyCode === 13) {
                                    handleReview(e, product);
                                    e.preventDefault();
                                }
                            },
                            children: product?.reviewDetails ? (
                                <ReviewDetailsModal
                                    toggleButton={
                                        <button ariaHidden={false} className="reviewDetailsbtn" ariaLabel={"Review Details " + product?.productName} tabIndex={0} role="button">
                                            Review details
                                        </button>
                                    }
                                    onClose={(e) => { handleCloseSignClick(e) }}
                                    {...getReviewDts(isClassicFlow && product?.name === 'YouTube TV' ? product?.classicDetails : product?.reviewDetails, product)}
                                />
                            ) : (
                                <></>
                            ),
                        }
                }),
                ...((serviceType == "TV" && achorLinkTitleForTV === "See channels" || (serviceType == "TV" && isClassicFlow && product?.name !== 'YouTube TV')) && {
                    rightTextLink: {
                        children: (
                            <>
                                <span className="screen-reader-only">Open modal showing</span>
                                Channels
                                <span className="screen-reader-only">for {productNameChannelLabel()}</span>
                            </>
                        ),
                        onClick: (e) => { openChannels(e, product) },
                        ariaLabel: productNameChannelLabel() + ' Channels list',
                        id: `DETAIL_${product?.id}`
                    }
                })
            },
            ...(!isClassicFlow && product?.extras?.length > 0 && serviceType !== 'INTERNET' && { contentTile: (product?.prodType != 'FVPRIMARY') ? formatExtras(product) : '' }),
            // CETC-146259 Suppressing special offer section if there are no special offers, the serviceType is not internet, the flowtype is classic, and the flowtype is ec
            ...(!isClassicFlow && product?.splOferFrmApi?.length > 0 && (product?.specialOffersfromApiArr?.[0]?.length > 0 || product?.specialOffersfromApiArr?.[1]?.length > 0) && serviceType === "INTERNET" && flowtype !== "EC" && { extras: formatExtrasForData(product) }),

            ...((typeof props.ecProfileCart?.ProfileDataProduct?.prodId == product?.id != "undefined" && props.ecProfileCart?.ProfileDataProduct?.prodId == product?.id && props.buildProduct?.internet?.selectedProduct == null) || (typeof props.ecProfileCart?.ProfileTVProduct?.prodId == product?.id != "undefined" && props.ecProfileCart?.ProfileTVProduct?.prodId == product?.id && props.buildProduct?.tv?.selectedProduct == null) || (props.flowType === 'SUPP' && props.buildProduct?.internet?.selectedProduct?.id == product?.id) ?
                {
                    footer: {
                        buttonGroup: {
                            childWidth: "100%",
                            alignment: "center",
                            rowQuantity: {
                                desktop: 1,
                                mobile: 1,
                                tablet: 1,
                            },
                            data: [
                                {
                                    surface: "dark",
                                    children: getEcCtaText(),
                                    ariaLabel: product?.name && !isChecked ? 'Selected' + product?.productName?.replace('4.0', '') : 'Removed' + product?.name?.replace('4.0', ''),
                                    disabled: isBlocked ? true : disableTV,
                                    use: "secondary",
                                    onClick: (e) => {
                                        if (serviceType === Service.tv && !isDisconnectFlow && product?.prodTypeValue === "Fios_Five") {
                                            handleClickFiosFive(e);
                                        } else {
                                            e.stopPropagation();
                                            clickFn();
                                        }
                                    },
                                },
                            ],
                        },
                    }
                }
                :
                {
                    footer: {
                        buttonGroup: {
                            childWidth: "100%",
                            alignment: "center",
                            rowQuantity: {
                                desktop: 1,
                                mobile: 1,
                                tablet: 1,
                            },
                            data: [
                                {
                                    surface: isChecked ? "dark" : "light",
                                    children: getEcCtaText(true),
                                    ariaLabel: product?.name && !isChecked ? 'Selected' + product?.name?.replace('4.0', '') : 'Removed' + product?.productName?.replace('4.0', ''),
                                    disabled: isBlocked ? true : disableTV,
                                    use: (isDisconnectFlow || isChecked) ? "secondary" : "primary",
                                    onClick: (e) => {
                                        if (serviceType === Service.tv && product?.prodTypeValue === "Fios_Five") {
                                            handleClickFiosFive(e);
                                        } else {
                                            e.stopPropagation();
                                            clickFn();
                                        }
                                    },
                                },
                            ],
                        },
                    }
                }
            ),
            ...(((!isEmployee && serviceType != "FIOS_VOICE") || (isEmployee && serviceType !== Service.internet && serviceType != "FIOS_VOICE")) && {
                banner: {
                    icon: { name: product?.banner && (product?.prodTypeValue !== "YOUTUBE" || (product?.prodTypeValue === "YOUTUBE" && lqState?.runtimeKey?.enableYTTV === 'Y')) ? getIcon(product?.banner?.split(" ")?.[0]) : '', ariaHidden: true },
                    children: <>
                        {(product?.prodTypeValue !== "YOUTUBE" || (product?.prodTypeValue === "YOUTUBE" && lqState?.runtimeKey?.enableYTTV === 'Y') && product?.banner) ? product?.banner : (disableTV ? 'Internet plan required' : '')}
                        {lqState?.runtimeKey?.enableYTTV === 'Y' && product?.prodTypeValue === "YOUTUBE" && <> <YouTubeBannerDetails isBanner={true} product={product} /></>}
                    </>,
                    ...(product?.banner && product?.bannerTooltip && product?.bannerTooltipTitle && {
                        tooltip: {
                            ariaLabel: `More information about ${product?.bannerTooltipTitle} tooltip`,
                            children: (<>
                                <b>{product?.bannerTooltipTitle}</b>
                                <br /><br />
                                {product?.bannerTooltip}
                            </>),
                        },
                    }),
                    ...((product?.prodTypeValue !== "YOUTUBE" || (product?.prodTypeValue === "YOUTUBE" && lqState?.runtimeKey?.enableYTTV === 'Y') && product?.banner) && { fillColor: 'red' }),
                    ...(!product?.banner && { fillColor: 'stone' }),
                }
            }),
            backgroundColor: 'stone'
        };
    };

    const entry = () => {
        return {
            backgroundColor: 'red',
            title: {
                children: <div style={{ minHeight: '678px' }}>
                    <h3 style={{ color: 'yellow', position: 'absolute', top: 10, left: 15 }}>Already a Verizon mobile customer?</h3>
                    <p style={{ fontSize: '24px', position: 'absolute', top: 150, left: 15, color: 'white' }}>Sign in to save <br /> up to $25/mo on <br /> Fios Home internet. </p>
                    <button style={{ borderRadius: '50px', position: 'absolute', textAlign: 'center', padding: '10px 18px', fontSize: '18px', backgroundColor: 'white', top: 275 }}>Sign In</button>
                </div>,
            },
            onClick: (e) => { modalAction.openModalWindow("mnhSignIn", dispatch) },
        }
    }

    const replaceDynamicVals = title => {
        const dynamicMap = {
            ytSupportedDevs: "https://support.google.com/youtubetv/answer/7129767?visit_id=1-636403200064571702-3219702076&p=supported_devices&rd=1",
            ytOfferTerms: "https://tv.youtube.com/learn/offer-terms/",
            ytOfferTermsLink: "https://tv.youtube.com/learn/offer-terms/",
            buyRouterImg: 'https://www.verizon.com/content/dam/verizon/personal/accordion-images/banners/WHW.png',
            rayBanImg: 'https://www.verizon.com/content/dam/verizon/personal/accordion-images/raybansmartGlasses.png',
            samsungImg: 'https://www.verizon.com/content/dam/verizon/personal/accordion-images/home-depot-offer.png',
            samsungModalLink: 'https://www.homedepot.com/b/Featured-Products-Eligible-Samsung-Appliances/N-5yc1vZ2fkpf1p',
            fiostvLink: 'https://sales-bau-sit3-publisher.ebiz.verizon.com/content/dam/verizon/personal/accordion-images/fiostv+.png'
        }
        // if(title?.includes('{{') && title?.includes('}}')) {

        // }
        return title?.replace('{{ytSupportedDevs}}', dynamicMap.ytSupportedDevs)?.replace('{{ytOfferTerms}}', dynamicMap.ytOfferTerms)?.replace('{{ytOfferTermsLink}}', dynamicMap.ytOfferTermsLink)?.replace('{{buyRouterImg}}', dynamicMap.buyRouterImg)?.replace('{{colon}}', ':')?.replace('{{rayBanImg}}', dynamicMap?.rayBanImg)?.replace('{{fiostvLink}}', dynamicMap?.fiostvLink)?.replace('{{samsungImg}}', dynamicMap.samsungImg)?.replace('{{samsungModalLink}}', dynamicMap?.samsungModalLink);
    };
    const closeReviewModel = (e, title) => {
        setIsCloseButton(true)
        let titleValue = title?.mainTitle ? title.mainTitle : props.product?.productName
        updateDetailValue(titleValue + ' - review details')
        updateSCTags('close button')
        document.getElementById('close-button').click()
    }
    const getReviewDts = (reviewDts, product) => {
        try {
            const title = reviewDts[0];

            if (Array.isArray(reviewDts) && reviewDts.length > 0) {
                reviewDts?.shift();
            }
            return {
                title: {
                    children: product?.productName ? product?.productName : product.id === 'R3577' ? 'Your Fios TV Spotlight' : '',
                    primitive: 'h2'
                },
                list: reviewDts?.map(dt => {
                    const title = isClassicFlow ? replaceDynamicVals(dt.title) : dt.title;
                    return {
                        title: {
                            children: <span dangerouslySetInnerHTML={{ __html: title }} />,
                            size: "medium",
                            bold: true,
                            primitive: 'h3',
                            tabIndex: '0'
                        },
                        subtitle: {
                            children: (
                                <span
                                    style={{ fontSize: "1rem" }}
                                    dangerouslySetInnerHTML={{ __html: dt.subtitle }}
                                />
                            ),
                        },
                        helperText: {
                            children: <span className="reviewDetailsText" dangerouslySetInnerHTML={{ __html: dt.helperText }} />,
                            // children: (
                            //   <span
                            //     style={{ fontSize: "0.6875rem" }}
                            //     dangerouslySetInnerHTML={{__html: dt.helperText}}
                            //   />
                            // ),
                        },
                        icon: {
                            name: dt.icon,

                        }
                    }
                }),
                buttonData: {
                    primary: {
                        children: "Close",
                        style: "margin-bottom: 20px",
                        // onClick: () => document.getElementById('close-button').click()
                        onClick: (e) => { closeReviewModel(e, title) }
                    }
                },
                theme: 'monarch'
            }
        } catch (e) {
            return null;
        }
    };

    const removeTxt60DaysStmt = (product) => {
        if (product?.id == "R0529") {
            if (buildProduct?.tv?.selectedProduct?.id === 'R3571') { return false; }
        }
        return true;

    }

    const getUnlimitedStreamFormat = () => {

        try {
            const priceFromApi = buildProduct?.ceApps?.equipments?.find(p => p?.prodType == "CEDEVICEAPPBNDL" && p?.id == "R0529")?.displayPrice?.replace(" more", "")?.replace(" less", "")?.replace("same price", "");
            let banner = "";
            let fillColor = "grayMedium";
            let surface = "light";
            let oldPrice = "";
            let pricingTitle = product?.displayPrice?.replace(" more", "")?.replace(" less", "")?.replace("same price", "") || priceFromApi;
            let pricingSubtitle = "";
            if (!product?.displayPrice?.toLowerCase()?.includes("included")) {
                pricingTitle = (pricingTitle?.includes("$") ? "" : "$")
                    + pricingTitle
                    + (pricingTitle?.includes("/mo") ? "" : "/mo");
            }
            if (product?.prodType == "CEDEVICEAPPBNDL" && product?.id == "R0529") {
                const selectedTVProduct = props.buildProduct?.tv?.selectedProduct;
                const cartTVProducts = Array.isArray(props.cart?.cartResponse?.tierContent) ? props.cart?.cartResponse?.tierContent[0]?.sections?.section?.find(c => c?.sectionName?.toLowerCase() == "service")?.subSections?.subSection?.find(d => d?.sectionType == "TVSTANDALONE" || d?.sectionType == "SVCCOMPONENT")?.products : [];
                const profileTVProducts = Array.isArray(props.profileCart?.cartResponse?.tierContent) ? props.profileCart?.cartResponse?.tierContent[0]?.sections?.section?.find(c => c?.sectionName?.toLowerCase() == "service")?.subSections?.subSection?.find(d => d?.sectionType == "SVCCOMPONENT" || d?.sectionType == "TVSTANDALONE")?.products : [];
                const ecProfileTVProducts = Array.isArray(props.ecProfileCart?.cartResponse?.tierContent) ? props.ecProfileCart?.cartResponse?.tierContent[0]?.sections?.section?.find(c => c?.sectionName?.toLowerCase() == "service")?.subSections?.subSection?.find(d => d?.sectionType == "SVCCOMPONENT" || d?.sectionType == "TVSTANDALONE")?.products : [];
                const hasMostFiosTV = (selectedTVProduct?.id == "R3575" || selectedTVProduct?.prodId == "R3575" || selectedTVProduct?.name?.includes("Most") || selectedTVProduct?.prodName?.includes("Most"))
                    || (Array.isArray(cartTVProducts) && cartTVProducts?.find(p => p?.id == "R3575" || p?.prodId == "R3575" || p?.name?.includes("Most") || p?.prodName?.includes("Most")))
                    || (!selectedTVProduct && Array.isArray(profileTVProducts) && profileTVProducts?.find(p => p?.id == "R3575" || p?.prodId == "R3575" || p?.name?.includes("Most") || p?.prodName?.includes("Most")))
                    || (!selectedTVProduct && Array.isArray(ecProfileTVProducts) && ecProfileTVProducts?.find(p => p?.id == "R3575" || p?.prodId == "R3575" || p?.name?.includes("Most") || p?.prodName?.includes("Most")))
                    ? true : false;
                const hasMundoTotal = (selectedTVProduct?.id == "R3573" || selectedTVProduct?.prodId == "R3573" || selectedTVProduct?.name?.includes("Mundo Total") || selectedTVProduct?.prodName?.includes("Mundo Total"))
                    || (Array.isArray(cartTVProducts) && cartTVProducts?.find(p => p?.id == "R3573" || p?.prodId == "R3573" || p?.name?.includes("Mundo Total") || p?.prodName?.includes("Mundo Total")))
                    || (!selectedTVProduct && Array.isArray(profileTVProducts) && profileTVProducts?.find(p => p?.id == "R3573" || p?.prodId == "R3573" || p?.name?.includes("Mundo Total") || p?.prodName?.includes("Mundo Total")))
                    || (!selectedTVProduct && Array.isArray(ecProfileTVProducts) && ecProfileTVProducts?.find(p => p?.id == "R3573" || p?.prodId == "R3573" || p?.name?.includes("Mundo Total") || p?.prodName?.includes("Mundo Total")))
                    ? true : false;
                const hasLocalTV = (selectedTVProduct?.id == "R3571" || selectedTVProduct?.prodId == "R3571" || selectedTVProduct?.name?.includes("Local") || selectedTVProduct?.prodName?.includes("Local"))
                    || (Array.isArray(cartTVProducts) && cartTVProducts?.find(p => p?.id == "R3571" || p?.prodId == "R3571" || p?.name?.includes("Local") || p?.prodName?.includes("Local")))
                    || (!selectedTVProduct && Array.isArray(profileTVProducts) && profileTVProducts?.find(p => p?.id == "R3571" || p?.prodId == "R3571" || p?.name?.includes("Local") || p?.prodName?.includes("Local")))
                    || (!selectedTVProduct && Array.isArray(ecProfileTVProducts) && ecProfileTVProducts?.find(p => p?.id == "R3571" || p?.prodId == "R3571" || p?.name?.includes("Local") || p?.prodName?.includes("Local")))
                    ? true : false;
                let unlimitedOfferRemainingDays = false;
                props?.buildProduct?.ceApps?.equipments?.filter((p) => {
                    if (p?.prodType === Service.ceAppsBundle && (p?.offerRemainingDays > -1 || p?.is60DayTrial)) {
                        unlimitedOfferRemainingDays = true;
                    }
                });
                if (props.flowType == 'NC') {
                    unlimitedOfferRemainingDays = true;
                }
                if (!product?.displayPrice || product?.displayPrice?.includes("$0.0") || product?.displayPrice?.includes("same price") || product?.displayPrice?.toLowerCase()?.includes("included")) {
                    if (hasMostFiosTV || hasMundoTotal) {
                        banner = "Included with your TV plan.";
                        fillColor = "red";
                        oldPrice = product?.originalPrice;
                        pricingTitle = "Included";
                    } else if (unlimitedOfferRemainingDays && !hasLocalTV) {
                        banner = "60 days on us, $20/mo after."; // "Included with your TV plan for 60 days. $20/mo after.";
                        fillColor = "red";
                        pricingTitle = "$0/mo";
                        pricingSubtitle = "$20/mo after 60 days";
                    }
                }
            }
            return {
                cap: {
                    children: banner,
                    fillColor: fillColor,
                    surface: surface,
                },
                newPrice: null,
                ...(oldPrice != ""
                    ? {
                        oldPrice: {
                            leadingText: {
                                children: "was"
                            },
                            price: product?.originalPrice,
                            term: "month"
                        }
                    }
                    : null
                ),
                pricingText: {
                    title: {
                        children: <span style={{ fontSize: "1.125rem" }}>{pricingTitle}</span>,
                        primitive: "p"
                    },
                    ...(pricingSubtitle != ""
                        ? {
                            subtitle: {
                                children: <span style={{ color: "grey", fontSize: "0.75rem" }}>{pricingSubtitle}</span>,
                            }
                        }
                        : null
                    ),
                }
            };
        } catch (e) {
            return null;
        }
    }

    function isPrdRemovedServiceFromProfile(product, subSectionType) {
        const cartRemovedProducts = props.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName === "Removed Services"))?.subSections?.subSection?.find(s => s?.sectionType === subSectionType)?.products;
        return Array.isArray(cartRemovedProducts) ? cartRemovedProducts?.some(p => p?.prodId === product?.id) : false;
    }

    function isPrdRemovedstrmServiceFromProfile(product, subSectionType) {
        const cartRemovedProducts = props.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName === "Removed Streaming Services"))?.subSections?.subSection?.find(s => s?.sectionType === subSectionType)?.products;
        return Array.isArray(cartRemovedProducts) ? cartRemovedProducts?.some(p => p?.prodId === product?.id) : false;
    }

    const formatAddonForSB = product => {
        const removeTxt60Days = removeTxt60DaysStmt(product);
        let disableDisneyPremium = false;
        let disablevfeaturePrd = false;

        if (product?.id === 'R0944' && props?.ecProfileCart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName?.toLowerCase() === "service"))?.subSections?.subSection?.find(s => s?.sectionType?.toLowerCase() === "streamingservices")?.products?.some(p => p?.prodId === 'R0944') && props?.cart?.cartData?.[0]?.removedStreamServices?.removedStream?.some(p => p?.prodId === 'R0944')) {
            disableDisneyPremium = true;
        }
        if (product?.id === 'N0019' && props?.ecProfileCart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName?.toLowerCase() === "equipment"))?.subSections?.subSection?.find(s => s?.sectionType?.toLowerCase() === "recording")?.products?.some(p => p?.prodId === 'N0019') && props?.cart?.cartData?.[0]?.removedequipments?.equipment?.some(p => p?.prodId === 'N0019')) {
            disableDisneyPremium = true;
        }
        if((product?.prodType === 'ACCESSPOINTBILLER' || product?.prodType === 'ACCESSPOINTNRCBILLER') && isChecked === true){
            disableDisneyPremium = true;
        }
        
        if((product?.prodType === 'ROUTERBILLER' || product?.prodType === 'ROUTERNRCBILLER') && product.prodTypeValue !== 'CUSTOMER_PROVIDED_ROUTER' && window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
            disableDisneyPremium = true;
        }

        return {
            backgroundColor: (product?.prodType != "FVPRIMARY") ? 'white' : 'black',
            title: {
                children: product?.countryName ? product?.countryName
                    : product?.OfferText === "NFL Sunday Ticket from YouTube on us ($449 Retail Value)" ? "NFL Sunday Ticket from YouTube on us" : product?.OfferText ? product?.productName
                        : product?.name === "I don't want to record on any TV's." ? "I don't want to record TV programs."
                            : product?.name === 'STARZ&reg; and STARZ ENCORE&reg;' ? 'STARZ® & STARZ ENCORE®'
                                : product?.name === 'Verizon World Plan 500' ? <span style={{ fontSize: '1.2rem' }}>Verizon <br aria-hidden="true" /> World Plan 500</span>
                                    : product?.name === 'Verizon World Plan 300' ? <span style={{ fontSize: '1.2rem' }}>Verizon <br aria-hidden="true" /> World Plan 300</span>
                                        : product?.name === 'Whole-Home Wi-Fi' || product?.name === 'Whole-Home Wi-Fi (Wi-Fi Access Point CHR30)' || product?.name === 'Whole Home Wi-Fi (Wi-Fi Access Point CHR30 Included)' ? <span style={{ fontSize: '1.2rem' }}>Whole-Home <br aria-hidden="true" /> Wi-Fi</span>
                                            : product?.name === 'Whole-Home Wi-Fi Plus' || product?.name === 'Whole-Home Wi-Fi Plus (Wi-Fi Access Point CHR30)' ? <span style={{ fontSize: '1.2rem' }}>Whole-Home <br aria-hidden="true" /> Wi-Fi Plus</span> 
                                                : product?.name === 'Rent: Wi-Fi Access Point CHR30' ? <span style={{ fontSize: '1.2rem' }}>Rent: Wi-Fi <br aria-hidden="true" /> Access Point</span> 
                                                    : product?.name === 'Buy: Wi-Fi Access Point CHR30' ? <span style={{ fontSize: '1.2rem' }}>Buy: Wi-Fi <br aria-hidden="true" /> Access Point</span>
                                                        : product?.name === 'Use your own router' ? <span style={{ fontSize: '1.2rem' }}>Use your own <br aria-hidden="true" /> router</span>
                                                            : product?.name === 'Rent: Verizon Router' ? <span style={{ fontSize: '1.2rem' }}>Router only <br aria-hidden="true" /> </span>
                                                                : (product?.prodType != "FVPRIMARY") ? product?.name === 'Router only' ? 'Router only' : (product?.name === 'List my number' ? 'I want to list my number' : product?.name) : product?.productName,
                primitive: "p",
                fontSize: '1.2rem'
            },
            ...((!isClassicFlow && serviceType == "BATTERY") ? ((product?.name === "Yes, I'd like a PowerReserve" || (product?.name?.indexOf("I'd like a PowerReserve") > -1) || (product?.name?.indexOf("I'd like a Power Reserv") > -1) || (product?.name?.indexOf("Yes, I'd like a") > -1)) ? {
                title: {
                    children: <>I'd like a PowerReserve.</>
                },
                pricingText: {
                    title: {
                        children: <>${product?.price}</>
                    },
                    subtitle: {
                        children: <p className={props.buildProduct.isECMNEnabled ? "powerreserv_onetime" : ""} style={{ 'font-size': '0.5rem' }}>One-time Charge</p>
                    }
                }
            } : {
                title: {
                    children: <>I don't want a<br /> PowerReserve.</>
                },
                pricingText: {
                    title: {
                        children: <></>
                    }
                }
            }) : null),
            ...(!isClassicFlow && product?.countryName && {
                pricingText: {
                    title: {
                        children: <p style={{ fontSize: '20px' }}>Included</p>
                    }
                },
            }),
            ...(!isClassicFlow && serviceType !== 'INTERNATIONALCHANNELPLAN' && product?.prodType !== "BATTERY" && product?.prodType !== "SLABATTERY" && product?.prodType !== 'SPLOFFER' && (product?.displayPrice != 'Included' && product?.displayPrice != '' && product?.displayPrice != '$0' && product?.displayPrice != null && product?.displayPrice !== '$0.00' && product?.displayPrice !== '$0.00/mo' && product?.displayPrice != '$null' && product?.id != "NORECORD" && product?.id != "NOCEAPPS" && product?.prodType != "DCELLTRAYSHIPMENT" && product?.id != "J4389" && product?.id != 'WINBACKYES') && product?.displayPrice?.toString().replace("$", "") !== '0.0' && !(product?.id == "R0529" && buildProduct?.tvConnections?.selectedProduct?.prodType === Service.dummyvRoom) ? {
                newPrice: {
                    price: (product?.id === 'R0704' || product?.id === 'R0703' || product?.name?.includes('Buy: Verizon Router') || product?.id === 'R4095' || product?.id === 'R4096' || product?.prodTypeValue === 'YOUTUBE' || product?.id === 'Y8265' || product?.id === 'Y8266' || product?.prodType === 'VHSBILLER' || product?.id === 'R3900' || product?.id === 'R3901') ? parseFloat(product?.price) : (product?.id == "R0529" ? (product?.price?.includes('more') ? product?.price?.replace('more', '') : product?.price) : (product?.prodType === Service.fneDeviceCount) ? (product?.price.indexOf(".00") > -1 ? parseInt(product?.price) : product?.price) : (product?.prodType != "FVPRIMARY") ? (product.prodType == 'OTTBASIC' ? product?.price : parseInt(product?.price))
                        : parseInt(product?.price?.replace('less', '')?.replace('more', ''))),
                    term: ['WINBACK', 'DCELLTRAY', 'DCELLTRAYSHIPMENT', 'ROUTERNRCBILLER', 'ACCESSPOINTNRCBILLER'].includes(product?.prodType) || props.buildProduct?.fne?.selectedProduct?.name?.toLowerCase()?.includes('buy') || (props.ecProfileCart?.ProfileFneProduct?.name?.toLowerCase()?.includes('buy') && props.buildProduct?.fne?.selectedProduct == null) ? 'none' : 'month',
                    leadingText: {
                        children: product?.productName === 'Fios Home Phone' ? '' : '',
                    },
                    superscript: (product?.prodType === 'OTTBASIC') ? (!hasYouTubeProfile && product?.prodTypeValue === 'YOUTUBE' && lqState?.runtimeKey?.enableYTTV === 'Y' ? '1' : '*') : '',
                    alignment: 'right'
                }
            }
                : ((product?.prodType == "DCELLTRAYSHIPMENT" || product?.prodType === "SLABATTERYSHIPMENT") ? {

                    pricingText: {
                        title: {
                            children: product?.displayPrice
                        }
                    }
                } : (isClassicFlow && !product?.name?.toLowerCase().includes('use my own router')) ? generateClassicDisplayPrice(product?.displayPrice, product) : '')
            ),
            ...((InHomeUtils.isNotEmpty(product?.originalPrice) && InHomeUtils.isNotNull(product?.originalPrice) && product?.prodType === 'VFEATURE' && (product?.prodTypeValue !== 'HD-DVR' && product?.prodTypeValue !== 'EM-DVR') && (parseInt(product?.price) !== parseInt(product?.originalPrice))) ? {
                oldPrice: {
                    leadingText: {
                        children: 'was'
                    },
                    price: product?.originalPrice,
                    term: 'month'
                }
            } : ""),
            ...((InHomeUtils.isNotEmpty(product?.originalPrice) && InHomeUtils.isNotNull(product?.originalPrice) && product?.prodType === 'VFEATURE' && product?.prodTypeValue == 'EM-DVR') ? {
                pricingText: {
                    newPrice: {
                        price: product?.displayPrice?.toString()?.replace(/\$/g, ""), // Two dollars were showing on for EM-DVR: https://onejira.verizon.com/browse/PRODDEF-35698
                        term: "month",
                    }
                },
            } : ""),
            // refer https://onejira.verizon.com/browse/ITT-687930


            ...(!isClassicFlow && ((product?.displayPrice == 'Included' || product?.displayPrice == '$0' || product?.displayPrice == '$0.00' || product?.displayPrice == '$0.00/mo') && product?.prodType !== "SLABATTERY") ? {
                pricingText: {
                    title: {
                        children: <>{
                            // product?.name?.toLowerCase().includes('use your own router')
                            product?.name?.toLowerCase().includes('use your own router') || product?.name == "Use my own router"
                                ? <span>$0<span style={{ 'font-size': '1.25rem' }}>/mo</span></span>
                                // https://onejira.verizon.com/browse/PRODDEF-39120 : Included Multi-Room, DVR Service etc services are not showing in Price place in BPP
                                : product?.prodType?.toUpperCase() === "PREMIUM" || product?.prodType?.toUpperCase() === "INTLPREMIUM" || product?.prodType?.toUpperCase() === "CEDEVICEAPPBNDL"
                                    ? null
                                    :
                                    <p style={{ 'font-size': '1.2rem' }}>{'Included'}</p>
                        }</>,
                        primitive: "p",
                        fontSize: '1.2rem'
                    }
                }
            } : ''
            ),
            ...((product?.id == 'WINBACKYES' || product?.id == "J4389") ? {
                pricingText: {
                    title: {
                        children: product?.displayPrice
                    },
                    subtitle: {
                        children: <p className={props.buildProduct.isECMNEnabled ? "powerreserv_onetime" : ""} style={{ 'font-size': '0.5rem' }}>One-time Charge</p>
                    }
                }
            } : null
            ),
            ...((product?.prodType != "DCELLTRAYSHIPMENT") ? {   // CETC-145954 fixed Srivid
                details: product?.prodType === 'fneDeviceCount' ? null : {
                    textLink: {
                        ariaLabel: "Review Details " + product?.productName,
                        role: "menu",
                        tabIndex:0,
                        onClick: (e) => { updateSCTags('Review Details') },
                        onKeyDown: (e) => {
                            if (e.keyCode === 32 || e.keyCode === 13) {
                                updateSCTags('Review Details');
                                e.preventDefault();
                            }
                        },
                        children: product?.reviewDetails || product?.ecReviewDetails
                            ? parentTiles
                                ? <ReviewDetailsModal toggleButton={
                                    <button ariaHidden={false} ariaLabel={"Review Details " + product?.productName} role="button" tabIndex={0}>Review details</button>}
                                    {...getReviewDts(product?.reviewDetails, product)} />
                                : ((product?.id == "R1749" || product?.id == "R1730") && props?.buildProduct?.isECMNEnabled && props?.flowType == "EC") ? getSubAccordionReviewDetails(product?.reviewDetails, product?.id) : (product?.prodType === "ROUTERBILLER" || product?.prodType === 'ACCESSPOINTBILLER') && product?.prodTypeValue === "CUSTOMER_PROVIDED_ROUTER" ? <button ariaHidden={false} className="reviewDetailsbtn" onClick={()=>setCustomRouterModalOpen(true)} ariaLabel={"Review Details " + product?.productName} role="button" tabIndex={0}>Review details</button>
                                : getSubAccordionReviewDetails(product?.reviewDetails, product?.id)
                            : <></>
                    },
                    ...((product?.prodType == "fiosTvOne" && product?.name == "Fios TV+") ? {
                        textLink: {
                            ariaLabel: "Review Details " + product?.productName,
                            role: "button",
                            children: <TextLink role="button" onClick={(e) => {
                                openFiosTvOneDetail()
                            }}>Review details</TextLink>
                        }
                    } : ''),

                    list:
                        product?.prodType == "CEDEVICEAPPBNDL" && product?.id == "NOCEAPPS" ? 'Opt out of connecting your own streaming devices to Fios TV'?.replace("<br />", "")?.split("&bull;")?.filter(n => n)?.map(prod => {
                            return {
                                children: prod
                            }
                        }) :
                            product?.prodType == "fiosTvOne" && product?.name == "Fios TV+" ? "Voice Remote.&bull;Stunning 4K Ultra HD picture quality.&bull;Wireless mini boxes with no cable required.&bull;Netflix and Youtube channels built in."?.replace("<br />", "")?.split("&bull;")?.filter(n => n)?.map(prod => {
                                return {
                                    children: prod
                                }
                            }) :
                                serviceType == "RECORDING" ?
                                    product?.description?.replace("<br />", "")?.split("&bull;")?.filter(n => n)?.map(prod => {
                                        return {
                                            children: prod
                                        }
                                    }) :
                                    serviceType == "INTERNATIONALCHANNEL" ?
                                        [product?.shortDescription, product?.description?.replace("<br />", "")?.split("&bull;")?.filter(n => n)]?.map(prod => {
                                            return {
                                                children: prod
                                            }
                                        })
                                        :
                                        product?.equipPromo?.map(prod => {
                                            return {
                                                children: prod
                                            }
                                        }),
                    backgroundColor: ((((product?.prodType == "CEDEVICEAPPBNDL" && product?.id == "NOCEAPPS") || product?.equipPromo?.length > 0 || product?.description != "") && product?.id != "NORECORD") && (serviceType != "CHANNEL") && (serviceType != "WINBACK") && (serviceType != "BATTERY") && (serviceType != "TECHSURE") && (serviceType != "BATTERY") && (serviceType != "BBUSHIPMENT") || (product?.prodType == "PREMIUM") || product?.id == "7486399" ? 'gray' : 'white')
                }
            } : ''),
            ...(serviceType === 'INTERNATIONALCHANNELPLAN' && {
                details: {
                    list: product?.equipPromo?.map(promo => {
                        return {
                            children: promo
                        }
                    })
                }
            }),
            ...((product?.prodType == "DCELLTRAY") ? ((product?.name == "Yes, I'd like a PowerReserve" || (product?.name?.indexOf("I'd like a Power Reserve") > -1)) ? {
                title: {
                    children: <>I'd like a PowerReserve.</>
                }
            } : {
                title: {
                    children: <>I don't want a<br /> PowerReserve.</>
                },
                pricingText: {
                }
            }) : null),
            ...((product?.prodType == "DCELLTRAYSHIPMENT") && (shippingPowerReserveProductIds.includes(product?.id))),
            // && {onClick: (e) => { e.stopPropagation(); clickFn(); }}
            ...(
                //  product.prodType != "DCELLTRAYSHIPMENT" ? 
                ((props.ecProfileCart?.ProfileVfutureProduct?.prodId == product?.id && typeof product?.id != "undefined") && props.buildProduct?.recording?.selectedProduct == null) || ((props.ecProfileCart?.ProfileCeAppProduct?.prodId == product?.id && typeof product?.id != "undefined") && props.buildProduct?.ceApps?.selectedProduct == null) || ((props.ecProfileCart?.ProfileRouterProduct?.prodId == product?.id && typeof product?.id != "undefined") && props.buildProduct?.router?.selectedProduct == null) && (props.flowType == "SUPP" ? true : props?.buildProduct?.isECMNEnabled) ?
                    {
                        footer: {
                            label: {
                                children: 'Selected',
                            },
                        }
                    }
                    :
                    {
                        footer: {
                            buttonGroup: {
                                childWidth: '100%',
                                alignment: 'center',
                                rowQuantity: {
                                    desktop: 1,
                                    mobile: 1,
                                    tablet: 1
                                },
                                data: [{
                                    children: (product?.prodType == "PREMIUM" || product?.prodType == "INTLPREMIUM" || product?.prodType == "DIGITALTIERS" || product?.prodType == "SPORTSPASS") ? <span style={{ border: 'none' }}>{isChecked ? 'Remove' : (product?.isprdOnProfile && !isPrdRemovedServiceFromProfile(product, "OTHERCHANNEL") ? 'Remove' : "Add")}</span> : (product?.prodType == "FVINTLPLAN" || product?.prodType == "VHSBILLER" || product?.prodType == "PRICEPLAN") ? <span style={{ border: 'none' }}>{isChecked ? 'Remove' : 'Select'}</span> : (product?.name === "Fios TV+" || product?.name === "Set-top box") ? <span style={{ border: 'none' }}>{(props.buildProduct?.tv?.StreamTVProductSelected && product?.name === "Fios TV+" || (product?.name === "Set-top box" && product?.isprdOnProfile && !props.buildProduct?.tv?.StreamTVProductSelected || product?.prodType == "PPP")) ? 'Selected' : 'Select'}</span> : <span style={{ border: 'none' }}>{(isChecked || (product?.prodType === 'OTTBASIC' && (product?.isprdOnProfile && !isPrdRemovedstrmServiceFromProfile(product, "STREAMINGSERVICES"))) || (product?.prodType === 'FVMAIL' && product?.isprdOnProfile) || ((product?.prodType === 'DCELLTRAY' || product?.prodType === 'SLABATTERY') && product?.isprdOnProfile && !props.buildProduct?.backup?.isShipmentRequired)) ? 'Selected' : 'Select'}
                                    </span>,
                                    ariaLabel: isChecked ? 'selected' + (product?.name?.replace('4.0', '') ? product?.name?.replace('4.0', '') : product?.OfferText) : 'select' + (product?.name?.replace('4.0', '') ? product?.name?.replace('4.0', '') : product?.OfferText),
                                    // surface: isChecked ? 'light' : 'dark',
                                    id: (!(product?.prodType == "PREMIUM" || product?.prodType == "INTLPREMIUM" || product?.prodType == "DIGITALTIERS" || product?.prodType == "SPORTSPASS") && isChecked) ? "btn-selected" : "btn-select",
                                    use: isChecked ? 'secondary' : (props.buildProduct?.tv?.StreamTVProductSelected && product?.name === "Fios TV+" || (product?.name === "Set-top box" && product?.isprdOnProfile && !props.buildProduct?.tv?.StreamTVProductSelected) || (product?.prodType === 'OTTBASIC' && (product?.isprdOnProfile && !isPrdRemovedstrmServiceFromProfile(product, "STREAMINGSERVICES"))) || ((product?.prodType === 'DCELLTRAY' || product?.prodType === 'SLABATTERY') && product?.isprdOnProfile && !props.buildProduct?.backup?.isShipmentRequired) || (product?.prodType === 'FVMAIL' && product?.isprdOnProfile) || ((product?.prodType == "PREMIUM" || product?.prodType == "DIGITALTIERS" || product?.prodType == "SPORTSPASS" || product?.prodType == 'PPP') && product?.isprdOnProfile && !isPrdRemovedServiceFromProfile(product, "OTHERCHANNEL")) || (product?.prodType == "FVINTLPLAN" || product?.prodType == "VHSBILLER" || product?.prodType == "PRICEPLAN")) ? 'secondary' : 'primary',
                                    disabled: isBlocked ? true : disableDisneyPremium,
                                    onClick: (e) => {
                                        if ((product?.prodType === "ROUTERBILLER" || product?.prodType === 'ACCESSPOINTBILLER') && product?.prodTypeValue === "CUSTOMER_PROVIDED_ROUTER" && !isChecked) {
                                            setCustomRouterModalOpen(true);
                                        } else {
                                            e.stopPropagation();
                                            const selectedProduct = props.buildProduct?.perks?.selectedProduct || [];
                                            const netflixPerk = selectedProduct?.find(item => {
                                                return (item?.prodId === "R3559")
                                            });

                                            if (product?.prodType === "PREMIUM" && product?.prodTypeValue === "HBO" && netflixPerk && !isChecked) {
                                                setPerksModalOpen(true);
                                            }
                                            clickFn();
                                        }
                                    }
                                }]
                            }
                        }

                    }

                //  : ''

            ),

            ...((showProdBanner || (product?.id == "NOCEAPPS" && product?.prodType == "CEDEVICEAPPBNDL") || (props?.flowtype == "EC" && ((!hasYouTubeProfile && product?.prodTypeValue === 'YOUTUBE' && lqState?.runtimeKey?.enableYTTV === 'Y') || product?.id === "Q8556"))) && {
                cap: {
                    children: <>
                        {product?.banner}
                        {!hasYouTubeProfile && lqState?.runtimeKey?.enableYTTV === 'Y' && product?.prodTypeValue === "YOUTUBE" && <> <YouTubeBannerDetails isBanner={true} product={product} /></>}
                    </>,
                    icon: { name: product?.banner && ((!hasYouTubeProfile && product?.prodTypeValue === "YOUTUBE" && lqState?.runtimeKey?.enableYTTV === 'Y')) ? getIcon(product?.banner?.split(" ")?.[0]) : '', ariaHidden: true },
                    ...(!product?.banner && { fillColor: 'grayMedium', surface: "light" }),
                }
            }),
            // ...((showProdBanner ||  product.id == "NOCEAPPS" && product.prodType == "CEDEVICEAPPBNDL") && {cap: {
            //   children: product?.banner,
            //   ...(!product?.banner && { fillColor: '', surface: "light" }),
            // }}),

            ...(((product?.prodType == "ROUTERBILLER" && product?.id == "R1739") || (product?.prodType == "ROUTERBILLER" && product?.id == "R1767")) && {
                cap: {
                    children: removeTxt60Days ? product?.banner : '',
                    ...((product?.banner && removeTxt60Days) ? { fillColor: "red" } : { fillColor: "grayMedium", surface: "light" }),
                }
            }),
            ...((product?.prodType == "CEDEVICEAPPBNDL" && product?.id == "R0529") && getUnlimitedStreamFormat()),
            ...((product?.prodType == "SPLOFFER" && (product?.id == "R3735" || product?.id == "R3872")) && {
                cap: {
                    children: 'Included with your ' + props.buildProduct?.internet?.selectedProduct?.name + ' plan',
                    fillColor: 'red'
                }
            }),
            ...(serviceType === Service.splOffer && product?.banner && {
                cap: {
                    children: product?.banner?.replace("[", "")?.replace("]", ""),
                    fillColor: 'red'
                }
            }),
            // ...(serviceType == 'ROUTER' && (product.prodType == 'SPLOFFER' || product?.displayPrice =='Included' || product?.displayPrice == '$0' || product?.displayPrice == '$0.00') ? {
            //   cap:{
            //     fillColor: 'red'
            //   }
            // }: {cap:{
            //   fillColor: 'grayMedium',
            //   surface: "light" 
            // } })
        }
    };

    const TVConnection = product => {
        //aria-label logic for tv count tiles
        const tvConnectionAriaLabel = () => {
            const unit = product?.unitCount ?? ""
            const priceTextSingle = "1 Tv connection included"
            const newPrice = product?.displayPrice?.split(".")[0] ?? ""
            const priceTextMultiple = unit + "Tv connections" + newPrice + "per month"
            return {
                mainblock: (unit == "1" ? priceTextSingle : priceTextMultiple),
                mainblockSelect: (unit == "1" ? "1 Tv connection select" : `${unit} Tv connections select`)
            }
        }
        return (
            <>
                {/* {product.unitCount !== "6" &&  */}
                <div className={props?.flowtype == "EC" ? 'ecTvConnections' : ''}>
                    <TileContainer
                        ariaLabel={tvConnectionAriaLabel().mainblock}
                        padding='12px'
                        aspectRatio='3:4'
                        width='174px'
                        height='228px'
                        onClick={(e) => {
                            e.stopPropagation();
                            // clickFn();
                        }}
                        backgroundColor="white"
                        showBorder={true}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <TileContainer aspectRatio='3:4' width='142px' height='96px' backgroundColor={""} padding='20px 55px'>
                                <Title primitive="p" color='black' size="XLarge"> {product?.unitCount}</Title>

                            </TileContainer>
                            <Title color='black' size='small' primitive="p">
                                <p style={{ 'text-align': 'center', 'font-size': '1.25rem', 'margin-bottom': '1rem' }}>{isClassicFlow ? (`${product?.displayPrice?.split(".")[0]}/mo*`) : (product?.unitCount == "1" ? "Included" : `${product?.displayPrice?.split(".")[0]}/mo*`)}</p></Title>

                            {props.ecProfileCart?.ProfileVRoomProduct?.prodId == product?.id && props.buildProduct?.vRoom?.selectedProduct == null ? (props?.flowtype == 'EC') ? <div className="vroomBtnStyling"><p className='vroom-selected-btn'>Selected</p></div> : <p className='vroom-selected-btn'>Selected</p> :
                                isChecked ? (
                                    (props?.flowtype == 'EC') ? <div className="vroomBtnStyling"><p className='vroom-selected-btn'>Selected</p></div> : <p className='vroom-selected-btn'>Selected</p>
                                ) : (
                                    <Button
                                        tabIndex="0"
                                        id="select-btn-tv"
                                        ariaLabel={tvConnectionAriaLabel().mainblockSelect}
                                        size="large"
                                        surface="light"
                                        disabled={isBlocked ? true : false}
                                        use="primary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            clickFn();
                                        }}
                                    >
                                        Select
                                    </Button>
                                )}
                        </div></TileContainer>
                </div>
            </>
        )
    }

    const WIFIExtender = product => {
        let showPrice = null
        if (props.buildProduct?.fne?.selectedProduct && props.buildProduct?.fne?.selectedProduct.id === product.id) {
            showPrice = parseFloat(props.buildProduct?.fne?.selectedProduct?.originalPrice) * parseFloat(props.buildProduct?.fne?.unitCount)

        }

        return (
            <> {product?.unitCount !== "6" && <TileContainer
                padding='12px'
                aspectRatio='3:4'
                width='174px'
                height='228px'
                onClick={(e) => {
                    e.stopPropagation();
                    // clickFn();
                }}
                backgroundColor="white"
                showBorder={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <TileContainer aspectRatio='3:4' width='142px' height='96px' backgroundColor={""} padding='20px 25px'>
                        <Title color='black' size="3XSmall"><b> {product?.name} </b></Title>

                    </TileContainer>
                    <Title color='black' size='small'  >
                        <p style={{ 'text-align': 'center', 'font-size': '1.25rem', 'margin-bottom': '1rem' }}>{showPrice ? '$' + showPrice + (!product.name?.toLowerCase()?.includes('buy') ? '/mo*' : '') : isClassicFlow ? (`${product?.displayPrice?.indexOf(".00") > -1 ? product?.displayPrice?.split(".")[0] : product?.displayPrice}/mo*`) : (product?.unitCount == "1" ? product?.displayPrice + (!product.name?.toLowerCase()?.includes('buy') ? '/mo*' : '') : `${product?.displayPrice?.indexOf(".00") > -1 ? product?.displayPrice?.split(".")[0] : showPrice !== null ? '$' + showPrice : product?.displayPrice}`)}</p></Title>

                    {props.ecProfileCart?.ProfileFneProduct?.prodId == product?.id && props.buildProduct?.fne?.selectedProduct == null ? <p className='fne-selected-btn'>Selected</p> :
                        isChecked ? (
                            <p className='fne-selected-btn'>Selected</p>
                        ) : (
                            <Button
                                id="select-btn-extender"
                                size="large"
                                surface="light"
                                disabled={isBlocked ? true : false}
                                use="primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    clickFn();
                                }}
                            >
                                Select
                            </Button>
                        )}
                </div></TileContainer>
            }</>
        )
    }
    function getTileWrapperClassList(className = "") {
        try {
            const classList = new Set(className?.split(" "));
            if (buildProduct?.mnTileStyles?.hasOwnProperty(product?.id)) {
                const mnTileStyle = buildProduct?.mnTileStyles?.[product?.id];
                const mnTileStyleKeys = Object.keys(mnTileStyle);
                mnTileStyleKeys.forEach(key => {
                    if (mnTileStyle?.[key] === true) {
                        classList.add(key);
                    } else {
                        classList.delete(key);
                    }
                });
            }
            if (product?.prodTypeValue === "YOUTUBE") {
                classList.add("yttvTile");
            } else {
                classList.delete("yttvTile");
            }
            return classList;
        } catch (e) {
            return null;
        }
    }

    // Adding width to adjust tiles in consistent width -- (For Standalone TV - router section)

    let containerStyle = {
        marginRight: isMobileView ? "0px" : "16px",
        display: 'flex',
        height: '100%',
        width: isMobileView ? "100%" : (product?.prodTypeValue === "YOUTUBE" ? '276px' : product?.prodType === "DCELLTRAYSHIPMENT" ? '360px' : "278px"),
    };
    if (serviceType !== 'VROOM' || serviceType !== 'FNE') {
        if ((buildProduct?.internet?.selectedProduct === null &&
            product?.name == "Buy: Verizon Router") ||
            product?.name !== "Buy: Verizon Router") {
            containerStyle.borderRadius = "25px";
            containerStyle.border = "1px solid rgba(216, 218, 218, 1)";
        }
    }

    if (serviceType === 'VROOM' || serviceType === 'FNE') {
        containerStyle.width = '';
    }
    if (serviceType === 'VROOM') {
        containerStyle.border = '';
    }
    if(serviceType === Service.internet){
        containerStyle.height = props?.buildProduct?.internet?.mnhSignupIndicator === "Y"?'100%':'';
    }

    let currentDataPlan = props.ecProfileCart?.ProfileDataProduct?.prodId;
    let currentRoutePlan = props.ecProfileCart?.ProfileRouterProduct?.prodId;
    let currentTvPlan = props.ecProfileCart?.ProfileTVProduct?.prodId;
    let currentCeAppPlan = props.ecProfileCart?.ProfileCeAppProduct?.prodId;
    let currentVRoomPlan = props.ecProfileCart?.ProfileVRoomProduct?.prodId;
    let currentVfuturePlan = props.ecProfileCart?.ProfileVfutureProduct?.prodId;
    let currentChannelPlan = props.ecProfileCart?.ProfileChannelProduct?.prodId
    let currentVoicePlan = props.ecProfileCart?.ProfileVoiceProduct?.prodId
    let parentClass = '';
    if (serviceType === 'RECORDING') {
        parentClass = 'mnTile_recording_section'
    }
    if (serviceType === 'ROUTER') {
        parentClass = 'mnTile_router_section'
    }
    if (serviceType === 'CUSTOMROUTER') {
        parentClass = 'mnTile_customer_section'
    }
    if (product?.prodType === 'CEDEVICEAPPBNDL') {
        parentClass = 'mnTile_stream_section'
    }
    if ((product?.prodType === "PREMIUM" || serviceType === Service.recording || serviceType === Service.intrnlChnl || serviceType === Service.ceAppsBundle) && props?.flowtype === 'EC') {
        parentClass += ' mnTile_ec_Channels_section'
    }
    if (product?.prodType === "OTTBASIC" && props?.flowtype === 'EC') {
        parentClass = 'mnTile_ec_Stream_section'
    }

    return (
        <>
            {product?.id === "R4047" || product?.id === "R4142" && (
                <SplOfferDispatchOverlay product={product?.id} />
            )}
            <div
                className={[...getTileWrapperClassList("")].join(" ")}
                style={{ marginBottom: isMobileView ? "0px" : "25px" }}
            >
                {isCustomRouterModalOpen && (
                    <CustomRouterModal
                        onClick={(e) => {
                            setCustomRouterModalOpen(false);
                            if (!isChecked) {
                                e?.stopPropagation();
                                clickFn();
                            }
                        }}
                        onClose={(e) => {
                            setCustomRouterModalOpen(false);
                        }}
                        opened={isCustomRouterModalOpen}
                    />
                )}
                {isCustomFiosDetailsModalOpen && (

                    <CustomFiosModal
                        onClick={(e) => {
                            setCustomFiosDetailsModalOpen(false);

                        }}
                        onClose={(e) => {
                            setCustomFiosDetailsModalOpen(false);
                        }}
                        opened={isCustomFiosDetailsModalOpen}
                    />
                )}
                {parentTiles && (currentDataPlan == product?.id || currentTvPlan == product?.id || currentVoicePlan == product?.id) ?
                    <StartNotification label={'Your current plan'} showTooltip={false} />
                    :
                    (typeof product?.id != "undefined" && (currentRoutePlan == product?.id || currentCeAppPlan == product?.id || currentVRoomPlan == product?.id || currentVfuturePlan == product?.id || currentChannelPlan == product?.id)) ?
                        (props?.flowtype == 'EC') ? <div className="testNotifictaion"> <StartNotification label={'Your current plan'} showTooltip={false} /></div> : <div> <StartNotification label={'Your current plan'} showTooltip={false} /></div> :
                        (product?.isprdOnProfile ? <StartNotification label={'Your current plan'} showTooltip={false} /> : '')
                }

                <div style={containerStyle} className={isBlocked ? 'tile-blocked' : `${constants?.INTERNETROUTER_IDS?.includes(product?.id) ? "internetRouter" : shippingPowerReserveProductIds?.includes(product?.id) && isChecked ? "selectedDaysShipping" : ""} ${parentClass}`}>

                    {parentTiles ?

                        <EmberPlanHome
                            product={product}
                            clickFn={clickFn}
                            serviceType={serviceType}
                            isChecked={isChecked}
                            achorLinkTitleForTV={achorLinkTitleForTV}
                            openModal={openModal}
                            handleClickFiosFive={handleClickFiosFive}
                            signInClick={signInClick}
                            isBlocked={isBlocked}
                            acc={acc}
                            onClickAccordion={onClickAccordion}
                            isCloseBtnClick={isCloseBtnClick}
                            setIsCloseButton={setIsCloseButton}
                            selectedSplOfferDetailsId={selectedSplOfferDetailsId}
                            setSelectedSplOfferDetailsId={setSelectedSplOfferDetailsId}
                        />
                        : (serviceType === "internet++") ?
                            <EmberEntryPoint />
                            : (serviceType === 'VROOM')
                                ? <EmberTVConnection
                                    product={product}
                                    clickFn={clickFn}
                                    isChecked={isChecked}
                                    isBlocked={isBlocked}
                                />
                                : (serviceType === 'FNE')
                                    ? <EmberWiFiExtender
                                        product={product}
                                        clickFn={clickFn}
                                        isChecked={isChecked}
                                        isBlocked={isBlocked}
                                    />
                                    : <> {props.buildProduct?.internet?.selectedProduct?.name && (props?.flowtype !== 'EC' && product?.name === 'Buy: Verizon Router') ? <></> :
                                    <AddOn {...formatAddonForSB(product)} />}
                                    {perksModalOpen ? <OpenPerksModal
                                        message="Netflix/Max Perk is subscribed to on account and will not be removed unless requested"
                                        onClose={(value) => {
                                            setPerksModalOpen(value);
                                        }}
                                        opened={perksModalOpen}
                                    /> : ''}
                                </>
                    }
                </div>
            </div>
        </>
    );
};


const mapStateToProps = state => {
    return {
        buildProduct: state.buildProduct,
        visitId: state.app.visitId,
        cart: state.cart,
        save: state.save,
        flowType: state.app.flowType,
        moveExp: state.moveExp.moveLandingExp,
        isFCPflow: state.loopQual.isFCPflow,
        isDoFlow: state.loopQual.doFlowDetails.isDoFlow,
        zip: state.loopQual.selectedState ? state.loopQual.selectedState.zip : '',
        tarCode: state.loopQual.selectedState ? state.loopQual.lqResponse.tarcode : '',
        cust_opt: state.moveExp.cust_opt,
        isFcpInProfile: state.loopQual.isFcpInProfile,
        lqState: state.loopQual,
        ecProfileCart: state.ecProfileCart,
        signIn: state.signIn,
        profileCart:state.profileCart
    }
}

export default connect(mapStateToProps)(MnTile);